import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  Alert,
  ToggleButtonGroup,
  ToggleButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Switch,
  Radio,
  RadioGroup,
  FormControlLabel
} from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorIcon from "@mui/icons-material/Error";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import HistoryIcon from "@mui/icons-material/History";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import InventoryIcon from "@mui/icons-material/Inventory";
import SendIcon from "@mui/icons-material/Send";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import PlaceIcon from "@mui/icons-material/PlaceOutlined";
import WorkIcon from "@mui/icons-material/Work";
import PersonIcon from "@mui/icons-material/Person";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutlined";
import moment from "moment";

import {
  FETCH_CLIENT_FIXED_ASSETS_LIST,
  FETCH_CLIENT_FIXED_ASSET_STATUS_TYPES,
  FETCH_CLIENT_ASSET_CATEGORIES,
  FETCH_CLIENT_ASSET_SUB_CATEGORIES,
  FETCH_CLIENT_JOBS,
  FETCH_CLIENTS_EMPLOYEES_V2
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { showSuccessToast, showErrorToast, showInfoToast } from "../../toast/toast";
import PictureViewer from "../../common/PictureViewer";
import Loader from "../../common/Loader";
import AssetBarcodeScanner from "./components/AssetBarcodeScanner";
import {
  fetchClientInventoryCheckQuestionsForms2,
  fetchClientInventoryCheckQuestions2,
  saveClientInventoryFormResponses,
  saveClientInventoryCheckAnswers,
  saveClientInventoryCheckPictures,
  fetchClientInventoryFormResponses2,
  fetchClientInventoryCheckAnswers2,
  fetchClientInventoryCheckPictures2
} from "./inventoryCheckQuestionsService";
import assetPlaceholder from "../../assets/images/image-unavailable.jpg";
import { BIBlue, BIRed } from "../../assets/helpers";

const fieldCardSx = {
  bgcolor: "#FFFFFF",
  border: "1px solid #ECEEF2",
  borderRadius: "14px",
  p: { xs: 2, sm: 2.5 },
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: "#D1D5DB"
  }
};

const correctionCardSx = {
  ...fieldCardSx,
  bgcolor: "#F8FAFC",
  border: "1px solid #CBD5E1",
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)"
};

const getStatusColors = (label) => {
  if (!label) return { bgcolor: "#F1F5F9", color: "#475569", border: "#CBD5E1" };
  const key = label.toLowerCase().trim();
  switch (key) {
    case "active":
    case "verified - all correct":
    case "verified":
    case "found":
      return { bgcolor: "#ECFDF5", color: "#047857", border: "#A7F3D0" };
    case "inactive":
    case "retired":
    case "decommissioned":
    case "disposed":
      return { bgcolor: "#F1F5F9", color: "#334155", border: "#CBD5E1" };
    case "missing":
    case "not found":
    case "lost":
      return { bgcolor: "#FEF2F2", color: "#B91C1C", border: "#FECACA" };
    case "discrepancies corrected":
    case "location updated":
    case "assignment updated":
      return { bgcolor: "#EFF6FF", color: "#1D4ED8", border: "#BFDBFE" };
    case "damaged":
    case "repair":
    case "defective":
      return { bgcolor: "#FFFBEB", color: "#B45309", border: "#FDE68A" };
    default:
      return { bgcolor: "#F8FAFC", color: "#475569", border: "#E2E8F0" };
  }
};

const mapAssetFromApi = (item) => {
  if (!item) return null;
  const categoryName =
    item.assetCategoryName ??
    item.categoryName ??
    item.CategoryName ??
    item.assetCategory ??
    item.Category ??
    item.category ??
    item.categoryTitle ??
    item.CategoryTitle ??
    "General";

  const subCategoryName =
    item.assetSubCategoryName ??
    item.subCategoryName ??
    item.SubCategoryName ??
    item.assetSubCategory ??
    item.subCategory ??
    item.SubCategory ??
    item.subcategory ??
    item.Subcategory ??
    item.subCategoryTitle ??
    item.SubCategoryTitle ??
    "";

  const rawLocType = String(item.locationType ?? item.LocationType ?? "place").toLowerCase();
  const rawLocId = String(item.location ?? item.Location ?? "");
  const rawLocTitle = String(item.locationTitle ?? item.LocationTitle ?? "");

  const locationVal =
    rawLocTitle ||
    rawLocId ||
    item.currentLocation ||
    item.CurrentLocation ||
    item.jobName ||
    item.JobName ||
    item.place ||
    item.site ||
    item.siteName ||
    "Not Specified";

  return {
    ...item,
    AssetId: item.id ?? item.assetId ?? item.AssetId,
    AssetCode: item.assetCode ?? item.AssetCode ?? item.code ?? item.barCode ?? item.equipmentNumber ?? item.EquipmentNumber ?? "N/A",
    AssetName: item.assetName ?? item.AssetName ?? item.name ?? item.title ?? item.asset ?? "Fixed Asset",
    CategoryId: item.assetCategoryId ?? item.categoryId ?? item.AssetCategoryId ?? item.assetCategory ?? item.Category ?? 0,
    CategoryName: categoryName,
    SubCategoryId: item.assetSubCategoryId ?? item.subCategoryId ?? item.AssetSubCategoryId ?? item.assetSubCategory ?? item.subCategory ?? item.SubCategory ?? 0,
    SubCategoryName: subCategoryName,
    SerialNo: item.serialNo ?? item.SerialNumber ?? item.serialNumber ?? "N/A",
    Make: item.make ?? item.Make ?? "",
    Model: item.model ?? item.Model ?? "",
    VendorId: item.vendorId ?? item.VendorId ?? "",
    VendorName: item.vendorName ?? item.VendorName ?? "",
    PurchasedDate: item.purchasedDate ?? item.PurchasedDate ?? "",
    Price: item.price ?? item.Price ?? "",
    WarrantyExpireDate: item.warrantyExpireDate ?? item.WarrantyExpireDate ?? "",
    BarCode: item.barCode ?? item.BarCode ?? item.assetCode ?? "",
    Comments: item.comments ?? item.Comments ?? "",
    TransferDate: item.transferDate ?? item.TransferDate ?? "",
    LocationType: rawLocType,
    LocationId: rawLocId,
    Location: locationVal,
    LocationTitle: locationVal,
    StatusId: item.statusId ?? item.StatusId ?? item.assetStatusId ?? 1,
    StatusTypeName: item.assetStatusName ?? item.statusName ?? item.statusTypeName ?? "Active",
    AssetStatusId: item.assetStatusId ?? item.statusId ?? 1,
    AssetStatusName: item.assetStatusName ?? item.statusName ?? item.statusTypeName ?? "Active",
    SupervisorId: item.supervisorId ?? item.SupervisorId ?? item.assignedToId ?? item.employeeId ?? 0,
    SupervisorName: item.supervisorName ?? item.SupervisorName ?? item.assignedToName ?? item.assignedTo ?? item.employeeName ?? "Not Assigned",
    AssignedToName: item.assignedToName ?? item.assignedTo ?? item.supervisorName ?? item.employeeName ?? "Not Assigned",
    AssignedToId: item.assignedToId ?? item.employeeId ?? item.clientEmployeeId ?? 0,
    StatusComments: item.statusComments ?? item.StatusComments ?? "",
    TransferStatus: item.transferStatus ?? item.TransferStatus ?? "",
    PictureList: item.pictureList ?? item.PictureList ?? [],
    AssetImageUrl: item.pictureList?.[0]?.fileUrl ?? item.pictureList?.[0]?.pictureUrl ?? item.imageUrl ?? item.assetImageUrl ?? assetPlaceholder
  };
};

export const renderWithItalicNA = (val) => {
  if (!val || val === "None recorded" || val === "Not Specified" || val === "Not Assigned" || val === "N/A") {
    return <Box component="span" sx={{ fontStyle: "italic", fontWeight: 600, color: "#94A3B8" }}>N/A</Box>;
  }
  if (typeof val === "string" && val.includes("N/A")) {
    const parts = val.split("N/A");
    return (
      <>
        {parts.map((part, i) => (
          <React.Fragment key={i}>
            {part}
            {i < parts.length - 1 && (
              <Box component="span" sx={{ fontStyle: "italic", fontWeight: 600, color: "#94A3B8" }}>
                N/A
              </Box>
            )}
          </React.Fragment>
        ))}
      </>
    );
  }
  return val;
};

const CurrentRecordDisplay = ({ label = "Current", value, icon: Icon, chipColor, isMissing }) => {
  const isValueEmpty = !value || value === "None recorded" || value === "Not Specified" || value === "Not Assigned" || value === "N/A";
  const missing = isMissing !== undefined ? isMissing : isValueEmpty;

  return (
    <Box
      sx={{
        mt: 1,
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1.2,
        px: 1.6,
        py: 0.75,
        bgcolor: missing ? "#FEF2F2" : "#F1F5F9",
        border: `1px solid ${missing ? "#FECACA" : "#CBD5E1"}`,
        borderRadius: "9px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)"
      }}
    >
      <Stack direction="row" spacing={0.8} alignItems="center">
        {Icon && <Icon sx={{ fontSize: 16, color: missing ? "#DC2626" : "#475569" }} />}
        <Typography
          sx={{
            fontSize: "0.74rem",
            color: missing ? "#991B1B" : "#475569",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.04em"
          }}
        >
          {label}:
        </Typography>
      </Stack>

      {chipColor ? (
        <Chip
          label={isValueEmpty ? "N/A" : value}
          size="small"
          sx={{
            fontWeight: 700,
            fontSize: "0.82rem",
            fontStyle: isValueEmpty ? "italic" : "normal",
            height: 24,
            borderRadius: "6px",
            border: `1px solid ${chipColor.border || "#CBD5E1"}`,
            bgcolor: chipColor.bgcolor || "#FFFFFF",
            color: chipColor.color || "#1E293B"
          }}
        />
      ) : (
        <Typography
          component="div"
          sx={{
            fontSize: "0.92rem",
            fontWeight: 700,
            color: missing ? "#991B1B" : "#0F172A",
            fontStyle: isValueEmpty ? "italic" : "normal"
          }}
        >
          {renderWithItalicNA(value)}
        </Typography>
      )}
    </Box>
  );
};

const YesNoToggle = ({ value, onChange, accentColor }) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(e, val) => {
        if (val !== null) onChange(val);
      }}
      sx={{
        bgcolor: "#F1F5F9",
        p: "3px",
        borderRadius: "10px",
        border: "1px solid #E2E8F0",
        flexShrink: 0,
        alignSelf: { xs: "flex-start", sm: "center" },
        "& .MuiToggleButton-root": {
          border: "none !important",
          borderRadius: "8px !important",
          px: 2,
          py: 0.5,
          fontSize: "0.82rem",
          textTransform: "none",
          fontWeight: 600,
          color: "#64748B",
          transition: "all 0.15s ease",
          "&.Mui-selected": {
            bgcolor: value === true ? "#DCFCE7" : "#FEE2E2",
            color: value === true ? "#15803D" : "#B91C1C",
            fontWeight: 700,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
          },
          "&:hover": {
            bgcolor: "rgba(255,255,255,0.7)"
          }
        }
      }}
    >
      <ToggleButton value={true}>
        <CheckIcon sx={{ fontSize: 15, mr: 0.4 }} /> Yes
      </ToggleButton>
      <ToggleButton value={false}>
        <ClearIcon sx={{ fontSize: 15, mr: 0.4 }} /> No
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

const YesNoPills = YesNoToggle;

const TrueFalseToggle = ({ value, onChange, trueLabel = "True", falseLabel = "False" }) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(e, nextVal) => {
        if (nextVal !== null) onChange(nextVal);
      }}
      sx={{
        bgcolor: "#F1F5F9",
        borderRadius: "10px",
        p: "3px",
        flexShrink: 0,
        alignSelf: { xs: "flex-start", sm: "center" },
        "& .MuiToggleButton-root": {
          border: "none !important",
          borderRadius: "8px !important",
          px: 2,
          py: 0.5,
          fontSize: "0.82rem",
          textTransform: "none",
          fontWeight: 600,
          color: "#64748B",
          transition: "all 0.15s ease",
          "&.Mui-selected": {
            bgcolor: value === true ? "#DCFCE7" : "#FEE2E2",
            color: value === true ? "#15803D" : "#B91C1C",
            fontWeight: 700,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
          },
          "&:hover": {
            bgcolor: "rgba(255,255,255,0.7)"
          }
        }
      }}
    >
      <ToggleButton value={true}>
        <CheckIcon sx={{ fontSize: 15, mr: 0.4 }} /> {trueLabel}
      </ToggleButton>
      <ToggleButton value={false}>
        <ClearIcon sx={{ fontSize: 15, mr: 0.4 }} /> {falseLabel}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

const CustomQuestionFieldControl = ({
  customType = "custom",
  options = [],
  value = "",
  selectedOptions = [],
  onChange = () => {},
  accentColor = BIBlue
}) => {
  // 1. Toggle / Custom with 2-3 options
  if (customType === "toggle" || (customType === "custom" && options.length <= 3)) {
    return (
      <ToggleButtonGroup
        value={value || options[0] || ""}
        exclusive
        size="small"
        onChange={(e, nextVal) => {
          if (nextVal !== null) {
            onChange(nextVal, [nextVal]);
          }
        }}
        sx={{
          bgcolor: "#F1F5F9",
          borderRadius: "10px",
          p: "3px",
          flexWrap: "wrap",
          alignSelf: { xs: "flex-start", sm: "center" },
          "& .MuiToggleButton-root": {
            border: "none !important",
            borderRadius: "8px !important",
            px: 2,
            py: 0.5,
            fontSize: "0.82rem",
            textTransform: "none",
            fontWeight: 600,
            color: "#64748B",
            transition: "all 0.15s ease",
            "&.Mui-selected": {
              bgcolor: accentColor,
              color: "#FFFFFF",
              fontWeight: 700,
              boxShadow: "0 1px 3px rgba(0,0,0,0.12)"
            },
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.7)"
            }
          }
        }}
      >
        {options.map((opt, i) => (
          <ToggleButton key={i} value={opt}>
            {opt}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  }

  // 2. Checklist (Multi-select)
  if (customType === "checklist") {
    const currentSelected =
      Array.isArray(selectedOptions) && selectedOptions.length > 0
        ? selectedOptions
        : typeof value === "string" && value
        ? value.split(",").map((s) => s.trim()).filter(Boolean)
        : [];

    const toggleOption = (opt) => {
      const exists = currentSelected.includes(opt);
      const updated = exists ? currentSelected.filter((x) => x !== opt) : [...currentSelected, opt];
      const joinedStr = updated.join(", ");
      onChange(joinedStr, updated);
    };

    return (
      <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: 0.8, alignItems: "center" }}>
        {options.map((opt, i) => {
          const isSelected = currentSelected.includes(opt);
          return (
            <Chip
              key={i}
              label={opt}
              clickable
              onClick={() => toggleOption(opt)}
              icon={isSelected ? <CheckIcon sx={{ fontSize: "16px !important", color: `${accentColor} !important` }} /> : undefined}
              sx={{
                borderRadius: "8px",
                fontWeight: isSelected ? 700 : 500,
                fontSize: "0.82rem",
                bgcolor: isSelected ? `${accentColor}18` : "#F1F5F9",
                color: isSelected ? accentColor : "#475569",
                border: isSelected ? `1.5px solid ${accentColor}` : "1px solid #E2E8F0",
                transition: "all 0.15s ease",
                "&:hover": {
                  bgcolor: isSelected ? `${accentColor}25` : "#E2E8F0"
                }
              }}
            />
          );
        })}
      </Stack>
    );
  }

  // 3. Dropdown / Select (or Custom with > 3 options)
  return (
    <FormControl size="small" sx={{ minWidth: 180, maxWidth: 320, bgcolor: "#FFFFFF" }}>
      <InputLabel>Select Option</InputLabel>
      <Select
        value={value || ""}
        label="Select Option"
        onChange={(e) => {
          const val = e.target.value;
          onChange(val, [val]);
        }}
        sx={{ borderRadius: "8px" }}
      >
        {options.map((opt, i) => (
          <MenuItem key={i} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const getQuestionFieldAndExpected = (q, asset) => {
  if (!asset) {
    return {
      hasCode: false,
      isCustomType: false,
      fieldKey: "TEXT",
      expectedValue: "",
      expectedValueType: "TEXT"
    };
  }

  const rawCode = (q?.QuestionCode || q?.questionCode || q?.Code || q?.code || "").trim();
  const code = rawCode.toUpperCase();
  const lowerCode = rawCode.toLowerCase();
  const rawField = (q?.QuestionField || q?.questionField || q?.Field || q?.field || "").trim();
  const field = rawField.toUpperCase();
  const title = (q?.QuestionTitle || q?.questionTitle || q?.Title || q?.title || "").toUpperCase().trim();

  // Custom interactive question codes: toggle, checklist, dropdown, select, custom
  // or questionField containing comma-separated values (e.g. "Damaged, Not Damaged", "Yes, No")
  if (
    lowerCode === "toggle" ||
    lowerCode === "checklist" ||
    lowerCode === "dropdown" ||
    lowerCode === "select" ||
    lowerCode === "custom" ||
    (rawField && rawField.includes(","))
  ) {
    const customType =
      lowerCode === "select"
        ? "dropdown"
        : ["toggle", "checklist", "dropdown", "custom"].includes(lowerCode)
        ? lowerCode
        : "custom";

    const options = rawField
      ? rawField.split(",").map((s) => s.trim()).filter(Boolean)
      : [];
    const finalOptions =
      options.length > 0 ? options : customType === "toggle" ? ["Yes", "No"] : ["Option 1", "Option 2"];

    return {
      hasCode: true,
      isCustomType: true,
      customType,
      options: finalOptions,
      rawOptionsString: rawField,
      fieldKey: "CUSTOM_OPTIONS",
      expectedValue: finalOptions[0] || "",
      expectedValueType: customType
    };
  }

  // If question code is empty or NONE: just True/False question
  if (!rawCode || code === "NONE" || code === "NULL") {
    return {
      hasCode: false,
      isCustomType: false,
      fieldKey: "BOOLEAN_ONLY",
      expectedValue: "True",
      expectedValueType: "BOOLEAN"
    };
  }

  // 1. LOCATION (location, locationTitle, locationType)
  if (
    code.includes("LOCATION") ||
    field.includes("LOCATION") ||
    rawCode === "location" ||
    rawCode === "locationTitle" ||
    rawCode === "locationType" ||
    title.includes("LOCATION") ||
    title.includes("SITE") ||
    title.includes("PLACE")
  ) {
    const rawAssetLocType = String(asset.locationType ?? asset.LocationType ?? "place").toLowerCase();
    const locType = ["job", "employee", "place", "location", "site"].includes(rawAssetLocType)
      ? (rawAssetLocType === "site" || rawAssetLocType === "location" ? "place" : rawAssetLocType)
      : "place";

    const locTitle =
      asset.LocationTitle ||
      asset.locationTitle ||
      asset.Location ||
      asset.location ||
      asset.currentLocation ||
      asset.CurrentLocation ||
      asset.jobName ||
      asset.JobName ||
      asset.place ||
      asset.site ||
      asset.siteName ||
      "Not Specified";

    if (rawCode === "locationType" || code === "LOCATIONTYPE") {
      return {
        hasCode: true,
        isCustomType: false,
        fieldKey: "TEXT",
        expectedValue: locType,
        expectedValueType: locType
      };
    }

    return {
      hasCode: true,
      isCustomType: false,
      fieldKey: "LOCATION",
      expectedValue: locTitle,
      expectedValueType: locType, // Sets Expected Value (job), Expected Value (employee), Expected Value (place) directly from API!
      locationType: locType,
      locationId: String(asset.LocationId ?? asset.locationId ?? asset.location ?? asset.Location ?? "")
    };
  }

  // 2. STATUS (assetStatusName, assetStatusId, statusId, statusComments)
  if (
    rawCode === "statusComments" ||
    code === "STATUSCOMMENTS" ||
    code.includes("STATUS_COMMENT")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXTAREA",
      expectedValue: asset.StatusComments || asset.statusComments || "None",
      expectedValueType: "statusComments"
    };
  }

  if (
    code.includes("STATUS") ||
    field.includes("STATUS") ||
    rawCode === "assetStatusName" ||
    rawCode === "assetStatusId" ||
    rawCode === "statusId" ||
    title.includes("STATUS")
  ) {
    const status = asset.StatusTypeName || asset.assetStatusName || asset.statusName || asset.Status || "Active";
    return {
      hasCode: true,
      fieldKey: "STATUS",
      expectedValue: status,
      expectedValueType: rawCode || "assetStatusName"
    };
  }

  // 3. CATEGORY (assetCategoryName, assetCategoryId, assetSubCategoryName, assetSubCategoryId)
  if (
    rawCode === "assetSubCategoryName" ||
    rawCode === "assetSubCategoryId" ||
    code.includes("SUBCAT")
  ) {
    return {
      hasCode: true,
      fieldKey: "CATEGORY",
      expectedValue: asset.SubCategoryName || asset.assetSubCategoryName || "Not Specified",
      expectedValueType: rawCode || "assetSubCategoryName"
    };
  }

  if (
    code.includes("CATEGORY") ||
    field.includes("CATEGORY") ||
    rawCode === "assetCategoryName" ||
    rawCode === "assetCategoryId" ||
    title.includes("CATEGORY")
  ) {
    const cat = `${asset.CategoryName || asset.assetCategoryName || "Not Specified"}${asset.SubCategoryName ? ` / ${asset.SubCategoryName}` : ""}`;
    return {
      hasCode: true,
      fieldKey: "CATEGORY",
      expectedValue: cat,
      expectedValueType: rawCode || "assetCategoryName"
    };
  }

  // 4. ASSIGNED EMPLOYEE / SUPERVISOR (supervisorName, supervisorId, employee, custodian)
  if (
    code.includes("ASSIGN") ||
    code.includes("EMPLOYEE") ||
    code.includes("CUSTODIAN") ||
    code.includes("SUPERVISOR") ||
    rawCode === "supervisorName" ||
    rawCode === "supervisorId" ||
    field.includes("EMPLOYEE") ||
    title.includes("ASSIGN") ||
    title.includes("EMPLOYEE") ||
    title.includes("SUPERVISOR") ||
    title.includes("CUSTODIAN")
  ) {
    const emp = asset.SupervisorName || asset.supervisorName || asset.AssignedToName || asset.assignedToName || asset.ClientEmployeeName || "Not Assigned";
    return {
      hasCode: true,
      fieldKey: "ASSIGNED_EMPLOYEE",
      expectedValue: emp,
      expectedValueType: rawCode || "supervisorName"
    };
  }

  // 5. EQUIPMENT NO / ASSET CODE / BARCODE (assetCode, barCode)
  if (
    code.includes("EQUIPMENT") ||
    code.includes("ASSET_CODE") ||
    code.includes("ASSETCODE") ||
    code.includes("BARCODE") ||
    rawCode === "assetCode" ||
    rawCode === "barCode" ||
    code.includes("TAG") ||
    title.includes("EQUIPMENT") ||
    title.includes("ASSET CODE") ||
    title.includes("TAG #") ||
    title.includes("BARCODE")
  ) {
    return {
      hasCode: true,
      fieldKey: "EQUIPMENT_NO",
      expectedValue: asset.AssetCode || asset.assetCode || asset.barCode || asset.BarCode || "N/A",
      expectedValueType: rawCode || "assetCode"
    };
  }

  // 6. SERIAL NUMBER (serialNo)
  if (
    code.includes("SERIAL") ||
    rawCode === "serialNo" ||
    field.includes("SERIAL") ||
    title.includes("SERIAL")
  ) {
    return {
      hasCode: true,
      fieldKey: "SERIAL_NO",
      expectedValue: asset.SerialNo || asset.serialNo || "N/A",
      expectedValueType: "serialNo"
    };
  }

  // 7. MAKE
  if (rawCode === "make" || code === "MAKE" || title.includes("MAKE")) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.Make || asset.make || "N/A",
      expectedValueType: "make"
    };
  }

  // 8. MODEL
  if (rawCode === "model" || code === "MODEL" || title.includes("MODEL")) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.Model || asset.model || "N/A",
      expectedValueType: "model"
    };
  }

  // 9. VENDOR (vendorId, vendorName)
  if (
    rawCode === "vendorName" ||
    rawCode === "vendorId" ||
    code.includes("VENDOR") ||
    title.includes("VENDOR")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.VendorName || asset.vendorName || (asset.VendorId || asset.vendorId ? `Vendor #${asset.VendorId || asset.vendorId}` : "N/A"),
      expectedValueType: rawCode || "vendorName"
    };
  }

  // 10. PURCHASED DATE
  if (
    rawCode === "purchasedDate" ||
    code.includes("PURCHASE") ||
    title.includes("PURCHASE")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.PurchasedDate || asset.purchasedDate || "N/A",
      expectedValueType: "purchasedDate"
    };
  }

  // 11. PRICE
  if (
    rawCode === "price" ||
    code === "PRICE" ||
    title.includes("PRICE") ||
    title.includes("COST")
  ) {
    const pVal = asset.Price !== undefined && asset.Price !== null && asset.Price !== ""
      ? String(asset.Price)
      : (asset.price !== undefined && asset.price !== null && asset.price !== "" ? String(asset.price) : "N/A");
    return {
      hasCode: true,
      fieldKey: "NUMBER",
      expectedValue: pVal,
      expectedValueType: "price"
    };
  }

  // 12. WARRANTY EXPIRE DATE
  if (
    rawCode === "warrantyExpireDate" ||
    code.includes("WARRANTY") ||
    title.includes("WARRANTY")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.WarrantyExpireDate || asset.warrantyExpireDate || "N/A",
      expectedValueType: "warrantyExpireDate"
    };
  }

  // 13. COMMENTS
  if (
    rawCode === "comments" ||
    code === "COMMENTS" ||
    code.includes("COMMENT")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXTAREA",
      expectedValue: asset.Comments || asset.comments || "None",
      expectedValueType: "comments"
    };
  }

  // 14. TRANSFER DATE / STATUS
  if (
    rawCode === "transferDate" ||
    code === "TRANSFERDATE" ||
    code.includes("TRANSFER_DATE")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.TransferDate || asset.transferDate || "N/A",
      expectedValueType: "transferDate"
    };
  }
  if (
    rawCode === "transferStatus" ||
    code === "TRANSFERSTATUS" ||
    code.includes("TRANSFER_STATUS")
  ) {
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: asset.TransferStatus || asset.transferStatus || "N/A",
      expectedValueType: "transferStatus"
    };
  }

  // 15. PICTURE LIST
  if (
    rawCode === "pictureList" ||
    code === "PICTURELIST" ||
    code.includes("PICTURE") ||
    code.includes("PHOTO")
  ) {
    const count = Array.isArray(asset.pictureList)
      ? asset.pictureList.length
      : (Array.isArray(asset.PictureList) ? asset.PictureList.length : 0);
    return {
      hasCode: true,
      fieldKey: "TEXT",
      expectedValue: count > 0 ? `${count} photo(s) recorded` : "No photos recorded",
      expectedValueType: "pictureList"
    };
  }

  // 16. DESCRIPTION / ASSET NAME (asset)
  if (
    rawCode === "asset" ||
    rawCode === "assetName" ||
    code.includes("NAME") ||
    code.includes("DESC") ||
    title.includes("NAME") ||
    title.includes("DESCRIPTION")
  ) {
    return {
      hasCode: true,
      fieldKey: "DESCRIPTION",
      expectedValue: asset.AssetName || asset.assetName || asset.asset || "N/A",
      expectedValueType: rawCode || "asset"
    };
  }

  // 17. CONDITION
  if (
    code.includes("CONDITION") ||
    field === "CONDITION" ||
    title.includes("CONDITION") ||
    title.includes("DAMAGE")
  ) {
    return {
      hasCode: true,
      fieldKey: "CONDITION",
      expectedValue: asset.Condition || asset.condition || "Good / Operational",
      expectedValueType: "CONDITION"
    };
  }

  // 18. IS FOUND / PRESENCE
  if (
    code.includes("FOUND") ||
    code.includes("PRESENT") ||
    title.includes("FOUND") ||
    title.includes("PRESENT")
  ) {
    return {
      hasCode: true,
      fieldKey: "IS_FOUND",
      expectedValue: "Present on site",
      expectedValueType: "BOOLEAN"
    };
  }

  // 19. Generic Direct Asset Property Lookup
  if (rawCode && asset[rawCode] !== undefined && asset[rawCode] !== null && typeof asset[rawCode] !== "object") {
    return {
      hasCode: true,
      fieldKey: field === "NUMBER" ? "NUMBER" : field === "TEXTAREA" ? "TEXTAREA" : "TEXT",
      expectedValue: String(asset[rawCode]),
      expectedValueType: rawCode
    };
  }

  // 20. Fallbacks by QuestionField
  if (field === "NUMBER") {
    return { hasCode: true, fieldKey: "NUMBER", expectedValue: "0", expectedValueType: "NUMBER" };
  }
  if (field === "TEXTAREA") {
    return { hasCode: true, fieldKey: "TEXTAREA", expectedValue: "None", expectedValueType: "TEXTAREA" };
  }
  if (field === "SWITCH" || field === "BOOLEAN") {
    return { hasCode: true, fieldKey: "SWITCH", expectedValue: "Yes", expectedValueType: "BOOLEAN" };
  }

  return {
    hasCode: true,
    fieldKey: "TEXT",
    expectedValue: asset.AssetName || "Verified",
    expectedValueType: rawCode || field || "TEXT"
  };
};

const InventoryCheck = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginData, selectedClientData } = useSelector((state) => state?.main || {});

  const clientId = selectedClientData?.ClientId;
  const userId = loginData?.userInformation?.UserId || loginData?.userInformation?.userId || loginData?.userInformation?.Id || loginData?.userId || loginData?.UserId || 1;
  const loggedInUserName =
    `${loginData?.userInformation?.FirstName || ""} ${loginData?.userInformation?.LastName || ""}`.trim() ||
    selectedClientData?.ClientEmployeeName ||
    "Field Auditor";
  const accentColor = selectedClientData?.AccentColor || BIBlue;

  // Tabs: 0 = Perform Inventory Check, 1 = Check History
  const [activeTab, setActiveTab] = useState(0);

  // Scanner modal state
  const [scannerOpen, setScannerOpen] = useState(false);

  // Search input & manual lookup
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  // Active Asset being checked
  const [currentAsset, setCurrentAsset] = useState(null);
  const [lastCheckInfo, setLastCheckInfo] = useState(null);

  // Dropdowns data (Categories, Statuses, Jobs, Employees)
  const [categoriesList, setCategoriesList] = useState([]);
  const [subCategoriesList, setSubCategoriesList] = useState([]);
  const [statusTypesList, setStatusTypesList] = useState([]);
  const [jobsList, setJobsList] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);

  // STATIC FORM STATE
  const [isAssetFound, setIsAssetFound] = useState(true);
  const [missingNotes, setMissingNotes] = useState("");

  const [isConditionGood, setIsConditionGood] = useState(true);
  const [damageSeverity, setDamageSeverity] = useState("Minor Damage");
  const [damageNotes, setDamageNotes] = useState("");

  const [isStatusCorrect, setIsStatusCorrect] = useState(true);
  const [correctedStatus, setCorrectedStatus] = useState("");

  const [isEquipmentNoCorrect, setIsEquipmentNoCorrect] = useState(true);
  const [correctedEquipmentNo, setCorrectedEquipmentNo] = useState("");

  const [isDescriptionCorrect, setIsDescriptionCorrect] = useState(true);
  const [correctedDescription, setCorrectedDescription] = useState("");

  const [isSerialNoCorrect, setIsSerialNoCorrect] = useState(true);
  const [correctedSerialNo, setCorrectedSerialNo] = useState("");

  const [isCategoryCorrect, setIsCategoryCorrect] = useState(true);
  const [correctedCategory, setCorrectedCategory] = useState(null);
  const [correctedSubCategory, setCorrectedSubCategory] = useState(null);

  const [isLocationCorrect, setIsLocationCorrect] = useState(true);
  const [locationType, setLocationType] = useState("place"); // place, job, employee
  const [correctedPlace, setCorrectedPlace] = useState("");
  const [correctedJob, setCorrectedJob] = useState(null);
  const [correctedLocationEmployee, setCorrectedLocationEmployee] = useState(null);

  const [isAssignmentCorrect, setIsAssignmentCorrect] = useState(true);
  const [correctedAssignedEmployee, setCorrectedAssignedEmployee] = useState(null);

  const [auditNotes, setAuditNotes] = useState("");
  const [photos, setPhotos] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const [expandedSections, setExpandedSections] = useState([0, 1, 2, 3, 4]);

  // Dynamic Questions & Forms state
  const [availableForms, setAvailableForms] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState("");
  const [dynamicQuestions, setDynamicQuestions] = useState([]);
  const [dynamicAnswers, setDynamicAnswers] = useState({});
  const [loadingDynamicQuestions, setLoadingDynamicQuestions] = useState(false);

  // Picture Viewer
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewerIndex, setPictureViewerIndex] = useState(0);
  const [pictureViewerList, setPictureViewerList] = useState([]);

  // Check History state
  const [historyList, setHistoryList] = useState([]);
  const [historySearch, setHistorySearch] = useState("");
  const [selectedHistoryDetail, setSelectedHistoryDetail] = useState(null);

  const fileInputRef = useRef(null);

  // Check router state for initial asset
  useEffect(() => {
    const passedAsset = location?.state?.initialAsset || location?.state?.selectedAsset;
    if (passedAsset) {
      handleSelectAsset(mapAssetFromApi(passedAsset));
    }
  }, [location?.state]);

  // Fetch Dropdown options for editing (Categories, Statuses, Jobs, Employees)
  useEffect(() => {
    if (!clientId) return;

    const fetchDropdowns = async () => {
      try {
        // Status types
        const statusRes = await Postrequestcall(
          FETCH_CLIENT_FIXED_ASSET_STATUS_TYPES,
          {
            PageNr: 1,
            NrOfRecPerPage: 100,
            FullSearch: "",
            SearchList: [{ ClientId: Number(clientId), clientId: Number(clientId) }],
            ClientId: Number(clientId),
            clientId: Number(clientId),
            UserId: Number(userId),
            IncludeRecordNr: true
          },
          loginData?.accessToken
        );
        if (statusRes?.data?.data) {
          setStatusTypesList(statusRes.data.data);
        }

        // Categories
        const catRes = await Postrequestcall(
          FETCH_CLIENT_ASSET_CATEGORIES,
          {
            PageNr: 1,
            NrOfRecPerPage: 100,
            FullSearch: "",
            SearchList: [{ ClientId: Number(clientId), clientId: Number(clientId) }],
            ClientId: Number(clientId),
            clientId: Number(clientId),
            UserId: Number(userId),
            IncludeRecordNr: true
          },
          loginData?.accessToken
        );
        if (catRes?.data?.data) {
          setCategoriesList(catRes.data.data);
        }

        // Jobs
        const jobsRes = await Postrequestcall(
          FETCH_CLIENT_JOBS,
          { ClientId: Number(clientId), UserId: Number(userId), PageNr: 1, NrOfRecPerPage: 100, SearchList: [{ active: true }] },
          loginData?.accessToken
        );
        if (jobsRes?.data?.data) {
          setJobsList(jobsRes.data.data);
        }

        // Employees
        const empRes = await Postrequestcall(
          FETCH_CLIENTS_EMPLOYEES_V2,
          { ClientId: Number(clientId), UserId: Number(userId), PageNr: 1, NrOfRecPerPage: 100, SearchList: [{ active: true }] },
          loginData?.accessToken
        );
        if (empRes?.data?.data) {
          setEmployeesList(empRes.data.data);
        }
      } catch (err) {
        console.error("Error loading dropdown options:", err);
      }
    };

    fetchDropdowns();
  }, [clientId, userId, loginData?.accessToken]);

  // Fetch subcategories when category changes
  useEffect(() => {
    if (!correctedCategory?.id || !clientId) {
      setSubCategoriesList([]);
      return;
    }
    const fetchSubCategories = async () => {
      try {
        const res = await Postrequestcall(
          FETCH_CLIENT_ASSET_SUB_CATEGORIES,
          {
            ClientId: Number(clientId),
            UserId: Number(userId),
            AssetCategoryId: correctedCategory.id,
            PageNr: 1,
            NrOfRecPerPage: 100
          },
          loginData?.accessToken
        );
        if (res?.data?.data) {
          setSubCategoriesList(res.data.data);
        }
      } catch (e) {
        console.error("Error fetching subcategories:", e);
      }
    };
    fetchSubCategories();
  }, [correctedCategory, clientId, userId, loginData?.accessToken]);

  // History loading states
  const [historyLoading, setHistoryLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);

  // Load history records from Backend API (Form Responses)
  const loadHistoryRecords = useCallback(async () => {
    setHistoryLoading(true);
    let apiRecords = [];

    if (clientId) {
      try {
        const searchList = [
          {
            ClientId: Number(clientId)
          }
        ];

        const [res, assetsRes] = await Promise.all([
          fetchClientInventoryFormResponses2({
            userId: Number(userId || 1),
            nrOfRecPerPage: 100,
            searchList,
            sortList: [{ FieldName: "Id", Direction: "DESC" }],
            token: loginData?.accessToken
          }),
          Postrequestcall(
            FETCH_CLIENT_FIXED_ASSETS_LIST,
            {
              NrOfRecPerPage: 100,
              PageNr: 1,
              FullSearch: "",
              FetchAllowedRecordsOnly: false,
              SearchList: [{ clientId: Number(clientId) }],
              UserId: Number(userId)
            },
            loginData?.accessToken
          ).catch((e) => {
            console.warn("Asset map fetch warning:", e);
            return null;
          })
        ]);

        const assetMap = new Map();
        const rawAssetList = assetsRes?.data?.data ?? assetsRes?.data?.Data ?? assetsRes?.data?.Result ?? [];
        if (Array.isArray(rawAssetList)) {
          rawAssetList.forEach((a) => {
            const mapped = mapAssetFromApi(a);
            if (mapped?.AssetId) {
              assetMap.set(Number(mapped.AssetId), mapped);
            }
          });
        }

        const respData = res?.data?.data || res?.data || [];
        const list = Array.isArray(respData) ? respData : [];

        apiRecords = list.map((item) => {
          const respId = Number(item.Id ?? item.id ?? item.FormResponseId ?? item.form_response_id ?? 0);
          const assetId = Number(item.AssetId ?? item.assetId ?? item.FixedAssetId ?? item.fixed_asset_id ?? 0);
          const assetInfo = (assetId && assetMap.get(assetId)) || (currentAsset?.AssetId === assetId ? currentAsset : null);

          const rawCode = item.AssetCode || item.assetCode || assetInfo?.AssetCode;
          const rawName = item.AssetName || item.assetName || assetInfo?.AssetName;

          return {
            id: respId,
            formResponseId: respId,
            assetId: assetId,
            assetCode: rawCode || (assetId ? `Asset #${assetId}` : "N/A"),
            assetName: rawName || "Fixed Asset",
            categoryName: item.CategoryName ?? item.categoryName ?? assetInfo?.CategoryName ?? "",
            subCategoryName: item.SubCategoryName ?? item.subCategoryName ?? assetInfo?.SubCategoryName ?? "",
            serialNo: item.SerialNo ?? item.serialNo ?? assetInfo?.SerialNo ?? "N/A",
            dateTime: item.CreatedDate ?? item.created_date ?? item.Date ?? item.dateTime ?? item.ModifiedDate ?? item.modified_date ?? new Date().toISOString(),
            auditorName: item.ClientEmployeeName ?? item.clientEmployeeName ?? item.AuditorName ?? item.auditorName ?? item.ModifiedByName ?? loggedInUserName,
            auditorId: item.ClientEmployeeId ?? item.clientEmployeeId ?? item.ModifiedBy ?? item.modifiedBy ?? userId,
            resultStatus: item.ResultStatus ?? item.resultStatus ?? "Verified",
            location: assetInfo?.CurrentLocation ?? item.LocationTitle ?? item.locationTitle ?? item.Location ?? item.location ?? "Not Specified",
            assignedTo: assetInfo?.AssignedToName ?? item.AssignedToName ?? item.assignedToName ?? item.EmployeeName ?? "Not Assigned",
            discrepancies: item.Discrepancies ?? item.discrepancies ?? "",
            notes: item.Note ?? item.note ?? item.Notes ?? item.notes ?? item.Comments ?? item.comments ?? "Inventory check completed.",
            photos: Array.isArray(item.photos) ? item.photos : [],
            formId: item.FormId ?? item.formId ?? null,
            formName: item.FormName ?? item.formName ?? "Inspection Check",
            formDescription: item.FormDescription ?? item.formDescription ?? "",
            organizationName: item.OrganizationName ?? item.organizationName ?? "",
            questionResponses: Array.isArray(item.questionResponses) ? item.questionResponses : []
          };
        });
      } catch (err) {
        console.warn("Error fetching form responses from API:", err);
      }
    }

    setHistoryList(apiRecords);
    setHistoryLoading(false);
    return apiRecords;
  }, [clientId, userId, loginData?.accessToken, loggedInUserName]);

  useEffect(() => {
    loadHistoryRecords();
  }, [loadHistoryRecords]);

  // Open History Detail and fetch submitted answers from API
  const handleOpenHistoryDetail = async (historyItem) => {
    setSelectedHistoryDetail(historyItem);
    const formResponseId = historyItem.formResponseId || historyItem.id;

    if (!formResponseId) return;

    setDetailLoading(true);
    try {
      // 1. Fetch submitted answers for this form response ID
      const ansRes = await fetchClientInventoryCheckAnswers2({
        userId: Number(userId || 1),
        nrOfRecPerPage: 100,
        searchList: [
          {
            formResponseId: Number(formResponseId)
          }
        ],
        token: loginData?.accessToken
      });

      const ansData = ansRes?.data?.data || ansRes?.data || [];
      const answersList = Array.isArray(ansData) ? ansData : [];

      // 2. Fetch submitted pictures for this form response ID
      let picturesList = [];
      try {
        const picRes = await fetchClientInventoryCheckPictures2({
          userId: Number(userId || 1),
          nrOfRecPerPage: 50,
          searchList: [
            {
              formResponseId: Number(formResponseId)
            }
          ],
          token: loginData?.accessToken
        });
        const picData = picRes?.data?.data || picRes?.data || [];
        const rawPics = Array.isArray(picData) ? picData : [];
        picturesList = rawPics
          .map((p) => p.FileUrl || p.fileUrl || p.ImageUrl || p.imageUrl || p.url || p.PictureUrl || p.pictureUrl)
          .filter(Boolean);
      } catch (pErr) {
        console.warn("Fetch check pictures API warning:", pErr);
      }

      if (answersList.length > 0 || picturesList.length > 0) {
        const mappedResponses = answersList.map((a, idx) => {
          const expVal = String(a.ExpectedValue ?? a.expectedValue ?? a.expected_value ?? "");
          const corrVal = String(a.CorrectedValue ?? a.correctedValue ?? a.corrected_value ?? a.expcted_value ?? expVal);
          const expType = String(a.ExpectedValueType ?? a.expectedValueType ?? a.expected_value_type ?? "");
          const corrType = String(a.CorrectedValueType ?? a.correctedValueType ?? a.corrected_value_type ?? "");
          const note = String(a.CorrectionNote ?? a.correctionNote ?? a.correction_note ?? "");
          const qId = Number(a.QuestionId ?? a.questionId ?? a.question_id ?? idx + 1);

          // Match question details from current or loaded questions if available
          const foundQ = dynamicQuestions.find((q) => Number(q.id) === qId);
          const qTitle = String(a.QuestionTitle ?? a.questionTitle ?? foundQ?.questionTitle ?? a.Question ?? a.Title ?? `Question #${idx + 1}`);

          const normExp = expVal.trim().toLowerCase();
          const normCorr = corrVal.trim().toLowerCase();
          const normNote = note.trim().toLowerCase();
          const normTitle = qTitle.trim().toLowerCase();

          let isCorrect = true;
          if (typeof a.isCorrect === "boolean") {
            isCorrect = a.isCorrect;
          } else if (normExp === normCorr && normCorr !== "") {
            // Exactly matching values (e.g. "Not Damaged" === "Not Damaged", "True" === "True")
            isCorrect = true;
          } else {
            const isTruthExp = ["true", "yes", "1", "ok", "verified", "correct"].includes(normExp);
            const isTruthCorr = ["true", "yes", "1", "ok", "verified", "correct"].includes(normCorr);

            if (isTruthExp && isTruthCorr) {
              isCorrect = true;
            } else if ((normExp.includes("?") || normExp === normTitle) && isTruthCorr && (!normNote || normNote === "yes" || normNote === "true")) {
              isCorrect = true;
            } else {
              isCorrect = false;
            }
          }

          return {
            questionId: qId,
            questionTitle: qTitle,
            questionSubTitle: a.QuestionSubTitle ?? a.questionSubTitle ?? foundQ?.questionSubTitle ?? a.SubTitle ?? "",
            questionCode: a.QuestionCode ?? a.questionCode ?? foundQ?.questionCode ?? a.Code ?? "",
            expectedValue: expVal,
            expectedValueType: expType,
            correctedValue: corrVal,
            correctedValueType: corrType,
            correctionNote: note,
            isCorrect
          };
        });

        setSelectedHistoryDetail((prev) => ({
          ...prev,
          questionResponses: mappedResponses.length > 0 ? mappedResponses : prev?.questionResponses,
          photos: picturesList.length > 0 ? picturesList : (prev?.photos || [])
        }));
      }
    } catch (err) {
      console.error("Error fetching submitted answers for form response:", err);
    } finally {
      setDetailLoading(false);
    }
  };

  // Load Question Forms & Questions specifically for Asset
  const loadFormAndQuestionsForAsset = useCallback(
    async (asset, targetFormId = null) => {
      const effectiveUserId = Number(userId || 1);
      setLoadingDynamicQuestions(true);

      try {
        let chosenFormId = targetFormId;
        let formsList = [];

        if (!chosenFormId) {
          // 1. Send Fixed Asset Id to fetch form API
          try {
            const assetFormRes = await fetchClientInventoryCheckQuestionsForms2({
              userId: effectiveUserId,
              searchList: [
                {
                  assetId: Number(asset?.AssetId || 0)
                }
              ],
              token: loginData?.accessToken
            });
            const assetFormData = assetFormRes?.data?.data || assetFormRes?.data || [];
            if (Array.isArray(assetFormData) && assetFormData.length > 0) {
              formsList = assetFormData.map((f) => {
                const fid = Number(f?.Id ?? f?.id ?? 0);
                return {
                  ...f,
                  Id: fid,
                  id: fid,
                  FormName: f?.FormName ?? f?.formName ?? `Form #${fid}`,
                  FormDescription: f?.FormDescription ?? f?.formDescription ?? ""
                };
              });
              chosenFormId = formsList[0].Id;
            }
          } catch (fErr) {
            console.warn("Asset-specific form search fallback:", fErr);
          }

          // Fallback to general forms list if no asset-specific form returned
          if (!chosenFormId) {
            const generalFormsRes = await fetchClientInventoryCheckQuestionsForms2({
              userId: effectiveUserId,
              nrOfRecPerPage: 100,
              token: loginData?.accessToken
            });
            const genData = generalFormsRes?.data?.data || generalFormsRes?.data || [];
            const rawForms = Array.isArray(genData) ? genData : [];
            formsList = rawForms.map((f) => {
              const fid = Number(f?.Id ?? f?.id ?? 0);
              return {
                ...f,
                Id: fid,
                id: fid,
                FormName: f?.FormName ?? f?.formName ?? `Form #${fid}`,
                FormDescription: f?.FormDescription ?? f?.formDescription ?? ""
              };
            });
            if (formsList.length > 0) {
              chosenFormId = formsList[0].Id;
            }
          }
        }

        if (formsList.length > 0) {
          setAvailableForms(formsList);
        }

        const activeFormId = chosenFormId || 1;
        setSelectedFormId(activeFormId);

        // 2. Use Form ID to Fetch Questions
        let questionsList = [];
        try {
          const qRes = await fetchClientInventoryCheckQuestions2({
            userId: effectiveUserId,
            formId: activeFormId,
            nrOfRecPerPage: 100,
            token: loginData?.accessToken
          });
          const qData = qRes?.data?.data || qRes?.data || [];
          const rawQList = Array.isArray(qData) ? qData : [];
          questionsList = rawQList.map((q) => {
            const qid = Number(q?.Id ?? q?.id ?? 0);
            return {
              ...q,
              Id: qid,
              id: qid,
              QuestionTitle: q?.QuestionTitle ?? q?.questionTitle ?? q?.Title ?? q?.title ?? "",
              QuestionSubTitle: q?.QuestionSubTitle ?? q?.questionSubTitle ?? q?.SubTitle ?? q?.subTitle ?? "",
              QuestionCode: q?.QuestionCode ?? q?.questionCode ?? q?.Code ?? q?.code ?? "",
              OrderId: Number(q?.OrderId ?? q?.orderId ?? q?.Order ?? q?.order ?? 1),
              QuestionField: q?.QuestionField ?? q?.questionField ?? q?.Field ?? q?.field ?? "text",
              FormId: Number(q?.FormId ?? q?.formId ?? activeFormId)
            };
          });
        } catch (qErr) {
          console.error("Error fetching questions for form:", qErr);
        }

        // Sort questions strictly by OrderId
        questionsList.sort((a, b) => (Number(a.OrderId) || 0) - (Number(b.OrderId) || 0));
        setDynamicQuestions(questionsList);

        // Initialize question answers from Asset response values
        const initialAnswers = {};
        questionsList.forEach((q) => {
          const exp = getQuestionFieldAndExpected(q, asset);
          const defaultVal = exp.isCustomType
            ? (exp.customType === "checklist" ? "" : (exp.options?.[0] || ""))
            : exp.expectedValue;

          const rawLocType = String(exp.locationType || asset?.LocationType || asset?.locationType || "place").toLowerCase();
          const normalizedLocType = rawLocType === "job" ? "job" : rawLocType === "employee" ? "employee" : "place";
          const rawLocId = String(asset?.LocationId ?? asset?.locationId ?? asset?.location ?? asset?.Location ?? "");
          const rawLocTitle = String(asset?.LocationTitle ?? asset?.locationTitle ?? asset?.Location ?? asset?.location ?? "");

          let matchedJob = null;
          if (normalizedLocType === "job" && (rawLocId || rawLocTitle)) {
            const foundJ = jobsList.find(
              (j) => String(j.id) === rawLocId || String(j.jobCode) === rawLocId || `${j.jobCode || ""} - ${j.name || ""}` === rawLocTitle
            );
            matchedJob =
              foundJ || {
                id: rawLocId,
                jobCode: rawLocTitle.includes(" - ") ? rawLocTitle.split(" - ")[0] : (rawLocId || rawLocTitle),
                name: rawLocTitle.includes(" - ") ? rawLocTitle.split(" - ").slice(1).join(" - ") : (rawLocTitle !== rawLocId ? rawLocTitle : "")
              };
          }

          let matchedEmp = null;
          if (normalizedLocType === "employee" && (rawLocId || rawLocTitle)) {
            const foundE = employeesList.find(
              (e) => String(e.id) === rawLocId || `${e.firstName || ""} ${e.lastName || ""}`.trim() === rawLocTitle
            );
            matchedEmp = foundE || { id: rawLocId, firstName: rawLocTitle, lastName: "" };
          }

          initialAnswers[q.Id] = {
            isCorrect: true,
            expectedValue: exp.expectedValue,
            expectedValueType: exp.expectedValueType,
            correctedValue: defaultVal,
            correctedValueType: exp.expectedValueType,
            selectedValue: defaultVal,
            selectedOptions: [],
            correctionNote: "",
            locationType: normalizedLocType,
            correctedPlace: normalizedLocType === "place" ? rawLocTitle : "",
            correctedJob: matchedJob,
            correctedLocationEmployee: matchedEmp,
            correctedCategory: null,
            correctedSubCategory: null,
            correctedEmployee: null,
            correctedStatus: asset?.StatusTypeName || "Active",
            damageSeverity: "Minor Damage"
          };
        });
        setDynamicAnswers(initialAnswers);
      } catch (err) {
        console.error("Error in loadFormAndQuestionsForAsset:", err);
      } finally {
        setLoadingDynamicQuestions(false);
      }
    },
    [userId, loginData?.accessToken, jobsList, employeesList]
  );

  // Retrieve last check for current asset
  const updateLastCheckForCurrentAsset = (asset, records = null) => {
    const list = records || historyList;
    if (!asset?.AssetId || !list) {
      setLastCheckInfo(null);
      return;
    }
    const match = list.find(
      (item) => Number(item.assetId) === Number(asset.AssetId) || item.assetCode === asset.AssetCode
    );
    if (match) {
      setLastCheckInfo({
        dateTime: match.dateTime,
        auditorName: match.auditorName || "Field Auditor",
        status: match.resultStatus || "Verified"
      });
    } else {
      setLastCheckInfo(null);
    }
  };

  // -------------------------------------------------------------
  // Asset Lookup (Barcode / Code Search)
  // -------------------------------------------------------------
  const handleBarcodeLookup = async (code) => {
    if (!code || !code.trim() || !clientId) return;
    const cleanCode = code.trim();
    setSearchLoading(true);
    setSearchResults([]);

    try {
      const searchPayload = {
        NrOfRecPerPage: 20,
        PageNr: 1,
        FullSearch: cleanCode,
        FetchAllowedRecordsOnly: false,
        SearchList: [{ clientId: Number(clientId) }],
        UserId: Number(userId)
      };

      const res = await Postrequestcall(
        FETCH_CLIENT_FIXED_ASSETS_LIST,
        searchPayload,
        loginData?.accessToken
      );

      let foundAssets = [];
      if (res?.status === 200 && res?.data) {
        const list = res.data.data ?? res.data.Data ?? res.data.Result ?? [];
        if (Array.isArray(list) && list.length > 0) {
          foundAssets = list;
        }
      }

      if (foundAssets.length === 1) {
        const selected = mapAssetFromApi(foundAssets[0]);
        await handleSelectAsset(selected);
        showSuccessToast(`Asset Identified: ${selected.AssetCode} - ${selected.AssetName}`);
      } else if (foundAssets.length > 1) {
        setSearchResults(foundAssets.map(mapAssetFromApi));
        showInfoToast(`Found ${foundAssets.length} matching assets. Please select one.`);
      } else {
        showErrorToast(`No fixed asset found with code "${cleanCode}".`);
      }
    } catch (err) {
      console.error("Asset lookup error:", err);
      showErrorToast("Failed to lookup asset. Please try again.");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSelectAsset = async (asset) => {
    if (!asset) return;
    setCurrentAsset(asset);
    setSearchResults([]);
    setSearchQuery("");
    setAuditNotes("");
    setPhotos([]);
    updateLastCheckForCurrentAsset(asset);

    // Send fixed asset id to fetch form API and get questions
    await loadFormAndQuestionsForAsset(asset);
  };

  const handleResetAsset = () => {
    setCurrentAsset(null);
    setLastCheckInfo(null);
    setSearchResults([]);
    setSearchQuery("");
    setDynamicQuestions([]);
    setDynamicAnswers({});
    setPhotos([]);
    setAuditNotes("");
  };

  // Image Upload handler
  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const newPhotos = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      name: file.name
    }));

    setPhotos((prev) => [...prev, ...newPhotos]);
    e.target.value = "";
  };

  const handleRemovePhoto = (index) => {
    setPhotos((prev) => prev.filter((_, i) => i !== index));
  };

  // -------------------------------------------------------------
  // Submit Inventory Check Record
  // -------------------------------------------------------------
  const handleSubmitCheck = async () => {
    if (!currentAsset) {
      showErrorToast("Please scan or search an asset before submitting.");
      return;
    }

    setSubmitting(true);
    try {
      // 1. Calculate discrepancies and verified status from answers
      const discrepancies = [];
      dynamicQuestions.forEach((q) => {
        const ans = dynamicAnswers[q.Id] || {};
        const exp = getQuestionFieldAndExpected(q, currentAsset);
        if (exp.isCustomType) {
          const selVal = String(ans.correctedValue !== undefined && ans.correctedValue !== null ? ans.correctedValue : (exp.options?.[0] || ""));
          const isNegative = /damage|broken|fault|defect|fail|poor|scrap|missing|lost/i.test(selVal);
          if (isNegative || ans.correctionNote) {
            const reason = ans.correctionNote ? ` (${ans.correctionNote})` : "";
            discrepancies.push(`${q.QuestionTitle}: Selected "${selVal}"${reason}`);
          }
        } else if (ans.isCorrect === false) {
          const reason = ans.correctionNote ? ` (${ans.correctionNote})` : "";
          if (!exp.hasCode) {
            discrepancies.push(`${q.QuestionTitle}: Marked False${reason}`);
          } else {
            discrepancies.push(
              `${q.QuestionTitle}: Expected "${exp.expectedValue}", Corrected to "${ans.correctedValue || "N/A"}"${reason}`
            );
          }
        }
      });

      let resultStatus = "Verified - All Correct";
      if (discrepancies.length > 0) {
        resultStatus = "Discrepancies Corrected";
      }

      const activeFormObj = availableForms.find((f) => f.Id === selectedFormId);

      // Assemble new audit check record for local history
      const newRecord = {
        id: Date.now(),
        assetId: currentAsset.AssetId,
        assetCode: currentAsset.AssetCode,
        assetName: currentAsset.AssetName,
        categoryName: currentAsset.CategoryName,
        subCategoryName: currentAsset.SubCategoryName,
        serialNo: currentAsset.SerialNo,
        dateTime: new Date().toISOString(),
        auditorName: loggedInUserName,
        auditorId: userId,
        resultStatus,
        location: currentAsset.LocationTitle || currentAsset.Location || "Not Specified",
        assignedTo: currentAsset.AssignedToName || "Not Assigned",
        discrepancies: discrepancies.length > 0 ? discrepancies.join("; ") : "All details verified and found correct",
        notes: auditNotes.trim() || "Inventory check completed successfully.",
        photos: photos.map((p) => p.url),
        formId: selectedFormId || null,
        formName: activeFormObj?.FormName || null,
        questionResponses: dynamicQuestions.map((q) => {
          const ans = dynamicAnswers[q.Id] || {};
          const exp = getQuestionFieldAndExpected(q, currentAsset);
          const isCorrect = ans.isCorrect !== false;
          const userVal = exp.isCustomType
            ? String(ans.correctedValue !== undefined && ans.correctedValue !== null ? ans.correctedValue : (exp.options?.[0] || ""))
            : (isCorrect ? exp.expectedValue : (ans.correctedValue || ""));

          return {
            questionId: q.Id,
            questionTitle: q.QuestionTitle,
            questionSubTitle: q.QuestionSubTitle,
            questionCode: q.QuestionCode,
            orderId: q.OrderId,
            expectedValue: ans.expectedValue !== undefined ? ans.expectedValue : exp.expectedValue,
            expectedValueType: ans.expectedValueType || exp.expectedValueType,
            isCorrect: isCorrect,
            correctedValue: userVal,
            correctedValueType: ans.correctedValueType || exp.expectedValueType,
            correctionNote: ans.correctionNote || ""
          };
        })
      };

      // 2. Call Backend API: Step A - Save User's Form Response
      const formPayload = {
        Id: 0,
        FormId: Number(selectedFormId || 1),
        ClientId: Number(clientId || selectedClientData?.ClientId || 0),
        ClientEmployeeId: Number(selectedClientData?.ClientEmployeeId || selectedClientData?.ClientEmpyId || 0),
        AssetId: Number(currentAsset.AssetId || 0),
        Note: auditNotes.trim(),
        ModifiedBy: Number(userId)
      };

      let createdResponseId = 0;
      try {
        const formRespRes = await saveClientInventoryFormResponses({
          userId,
          saveList: [formPayload],
          token: loginData?.accessToken
        });

        createdResponseId =
          formRespRes?.data?.data?.[0]?.objData?.id ||
          formRespRes?.data?.data?.[0]?.objData?.Id ||
          formRespRes?.data?.data?.[0]?.Id ||
          formRespRes?.data?.data?.[0]?.id ||
          formRespRes?.data?.RecordId ||
          formRespRes?.data?.recordId ||
          formRespRes?.data?.Id ||
          formRespRes?.data?.id ||
          0;
      } catch (formApiErr) {
        console.warn("Save form response API warning:", formApiErr);
      }

      if (createdResponseId) {
        newRecord.formResponseId = createdResponseId;

        // Step B - Save Answers using the Generated Form Response ID
        if (dynamicQuestions.length > 0) {
          const answersPayload = dynamicQuestions.map((q) => {
            const ans = dynamicAnswers[q.Id] || {};
            const exp = getQuestionFieldAndExpected(q, currentAsset);
            const isCorrect = ans.isCorrect !== false;
            const expVal = String(ans.expectedValue !== undefined ? ans.expectedValue : exp.expectedValue);
            const expType = String(ans.expectedValueType || exp.expectedValueType || "text");
            
            let corrVal = "";
            let corrType = String(ans.correctedValueType || expType);
            let corrNote = String(ans.correctionNote || "");

            if (exp.isCustomType) {
              corrVal = String(
                ans.correctedValue !== undefined && ans.correctedValue !== null && ans.correctedValue !== ""
                  ? ans.correctedValue
                  : (exp.options?.[0] || "")
              );
            } else if (isCorrect) {
              corrVal = expVal;
              corrNote = "";
            } else {
              corrVal = String(ans.correctedValue !== undefined ? ans.correctedValue : expVal);
            }

            return {
              Id: 0,
              ClientId: Number(clientId || selectedClientData?.ClientId || 0),
              ClientEmployeeId: Number(selectedClientData?.ClientEmployeeId || selectedClientData?.ClientEmpyId || 0),
              QuestionId: Number(q.Id),
              ExpectedValue: expVal,
              ExpectedValueType: expType,
              CorrectionNote: corrNote,
              CorrectedValue: corrVal,
              CorrectedValueType: corrType,
              FormResponseId: Number(createdResponseId),
              ModifiedBy: Number(userId)
            };
          });

          try {
            await saveClientInventoryCheckAnswers({
              userId,
              saveList: answersPayload,
              token: loginData?.accessToken
            });
          } catch (ansErr) {
            console.warn("Save answers API warning:", ansErr);
          }
        }

        // Step C - Save Pictures attached by user
        if (photos.length > 0) {
          for (const photoItem of photos) {
            try {
              await saveClientInventoryCheckPictures({
                id: 0,
                formId: Number(selectedFormId || 1),
                formResponseId: Number(createdResponseId),
                clientId: Number(clientId || selectedClientData?.ClientId || 0),
                clientEmployeeId: Number(selectedClientData?.ClientEmployeeId || selectedClientData?.ClientEmpyId || 0),
                imageUrl: photoItem.file || photoItem.url,
                modifiedBy: Number(userId),
                token: loginData?.accessToken
              });
            } catch (picErr) {
              console.warn("Save picture API warning:", picErr);
            }
          }
        }
      }

      showSuccessToast(`Inventory Check recorded successfully: ${resultStatus}`);
      handleResetAsset();
      setActiveTab(1);
      await loadHistoryRecords();
    } catch (err) {
      console.error("Submission error:", err);
      showErrorToast("Failed to save Inventory Check record.");
    } finally {
      setSubmitting(false);
    }
  };

  // Filtered History
  const filteredHistory = historyList.filter((item) => {
    if (historySearch) {
      const q = historySearch.toLowerCase();
      const code = (item.assetCode || "").toLowerCase();
      const name = (item.assetName || "").toLowerCase();
      const auditor = (item.auditorName || "").toLowerCase();
      const loc = (item.location || "").toLowerCase();
      const status = (item.resultStatus || "").toLowerCase();
      const note = (item.notes || "").toLowerCase();
      const form = (item.formName || "").toLowerCase();
      return (
        code.includes(q) ||
        name.includes(q) ||
        auditor.includes(q) ||
        loc.includes(q) ||
        status.includes(q) ||
        note.includes(q) ||
        form.includes(q)
      );
    }
    return true;
  });

    return (
    <Box sx={{ backgroundColor: "#F7F8FA", minHeight: "calc(100vh - 110px)", pb: 6, overflow: "scroll", scrollbarWidth: "none" }}>
      <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2.5, maxWidth: 1300, mx: "auto" }}>
        {/* Top Header Card */}
        <Card
          variant="outlined"
          sx={{
            borderRadius: "14px",
            mb: 3,
            bgcolor: "#FFFFFF",
            border: "1px solid #ECEEF2"
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5 }, "&:last-child": { pb: { xs: 2, sm: 2.5 } } }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems={{ xs: "flex-start", sm: "center" }}
              justifyContent="space-between"
              sx={{ width: "100%" }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
                  <Button
                    size="small"
                    variant="text"
                    startIcon={<ArrowBackIosNewIcon sx={{ fontSize: "14px !important" }} />}
                    onClick={() => navigate(`/client/${clientId}/fixed-assets`)}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      color: "#64748B",
                      px: 1,
                      py: 0.3,
                      borderRadius: "8px",
                      fontSize: "0.82rem",
                      "&:hover": { bgcolor: "#F1F5F9", color: "#1E293B" }
                    }}
                  >
                    Fixed Assets
                  </Button>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: "#1A1D23", letterSpacing: "-0.02em" }}>
                    Inventory Check
                  </Typography>
                  <Chip
                    size="small"
                    label="Physical Audit"
                    sx={{
                      bgcolor: `${accentColor}10`,
                      color: accentColor,
                      fontWeight: 600,
                      borderRadius: "6px",
                      fontSize: "0.72rem",
                      height: 22
                    }}
                  />
                </Stack>
                <Typography variant="body2" sx={{ color: "#9499A8", fontSize: "0.82rem", mt: 0.3 }}>
                  Verify fixed assets physically on site, record condition, verify location/assignment, and track check history
                </Typography>
              </Box>

              {/* Tab Switcher */}
              <Stack direction="row" spacing={1.2} alignItems="center" flexWrap="wrap" sx={{ ml: { sm: "auto" } }}>
                {/* Segmented Tab Switch Control */}
                <Box
                  sx={{
                    bgcolor: "#F5F6FA",
                    p: "4px",
                    borderRadius: "10px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    border: "1px solid #ECEEF2",
                    flexShrink: 0
                  }}
                >
                  <Button
                    variant={activeTab === 0 ? "contained" : "text"}
                    startIcon={<FactCheckIcon sx={{ fontSize: "17px !important" }} />}
                    onClick={() => setActiveTab(0)}
                    sx={{
                      borderRadius: "8px",
                      px: 2,
                      py: 0.6,
                      textTransform: "none",
                      fontWeight: activeTab === 0 ? 650 : 500,
                      fontSize: "0.84rem",
                      bgcolor: activeTab === 0 ? accentColor : "transparent",
                      color: activeTab === 0 ? "#FFFFFF !important" : "#6B7280",
                      boxShadow: activeTab === 0 ? "0 1px 4px rgba(0,0,0,0.12)" : "none",
                      "&:hover": {
                        bgcolor: activeTab === 0 ? accentColor : "#ECEEF2",
                        color: activeTab === 0 ? "#FFFFFF" : "#1A1D23"
                      }
                    }}
                  >
                    Inventory Check
                  </Button>
                  <Button
                    variant={activeTab === 1 ? "contained" : "text"}
                    startIcon={<HistoryIcon sx={{ fontSize: "17px !important" }} />}
                    onClick={() => setActiveTab(1)}
                    sx={{
                      borderRadius: "8px",
                      px: 2,
                      py: 0.6,
                      textTransform: "none",
                      fontWeight: activeTab === 1 ? 650 : 500,
                      fontSize: "0.84rem",
                      bgcolor: activeTab === 1 ? accentColor : "transparent",
                      color: activeTab === 1 ? "#FFFFFF !important" : "#6B7280",
                      boxShadow: activeTab === 1 ? "0 1px 4px rgba(0,0,0,0.12)" : "none",
                      "&:hover": {
                        bgcolor: activeTab === 1 ? accentColor : "#ECEEF2",
                        color: activeTab === 1 ? "#FFFFFF" : "#1A1D23"
                      }
                    }}
                  >
                    Check History
                  </Button>
                </Box>
              </Stack>
            </Stack>
          </CardContent>
        </Card>

        {/* TAB 0: PERFORM INVENTORY CHECK */}
        {activeTab === 0 && (
          <Stack spacing={2.5}>
            {/* Step 1: Asset Lookup / Scanner Card */}
            <Card
              variant="outlined"
              sx={{
                borderRadius: "14px",
                bgcolor: "#FFFFFF",
                border: "1px solid #ECEEF2"
              }}
            >
              <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#1A1D23", mb: 2, fontSize: "0.95rem" }}>
                  1. Identify Fixed Asset
                </Typography>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1.5}
                  alignItems="stretch"
                  sx={{ width: "100%" }}
                >
                  <Button
                    variant="contained"
                    startIcon={<QrCodeScannerIcon />}
                    onClick={() => setScannerOpen(true)}
                    sx={{
                      height: 44,
                      px: 2.5,
                      borderRadius: "10px",
                      bgcolor: accentColor,
                      color: "#FFFFFF",
                      fontWeight: 600,
                      textTransform: "none",
                      fontSize: "0.875rem",
                      boxShadow: "none",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      "&:hover": { bgcolor: accentColor, opacity: 0.92 }
                    }}
                  >
                    Scan QR / Barcode
                  </Button>

                  <TextField
                    fullWidth
                    placeholder="Search by Equipment #, Asset Code, or Serial Number..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleBarcodeLookup(searchQuery);
                    }}
                    sx={{
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        height: 44,
                        borderRadius: "10px",
                        bgcolor: "#FAFBFC",
                        fontSize: "0.875rem",
                        "& fieldset": { borderColor: "#ECEEF2" },
                        "&:hover fieldset": { borderColor: accentColor },
                        "&.Mui-focused fieldset": { borderColor: accentColor }
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#9499A8", fontSize: 20 }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleBarcodeLookup(searchQuery)}
                            disabled={searchLoading || !searchQuery.trim()}
                            sx={{
                              height: 32,
                              borderRadius: "7px",
                              bgcolor: accentColor,
                              textTransform: "none",
                              fontWeight: 600,
                              boxShadow: "none",
                              px: 2,
                              fontSize: "0.8rem",
                              "&:hover": { bgcolor: accentColor, opacity: 0.92 }
                            }}
                          >
                            {searchLoading ? <CircularProgress size={14} sx={{ color: "#FFFFFF" }} /> : "Search"}
                          </Button>
                        </InputAdornment>
                      )
                    }}
                  />
                </Stack>

                {/* Multiple Search Results list */}
                {searchResults.length > 0 && (
                  <Box sx={{ mt: 2.5, pt: 2, borderTop: "1px solid #ECEEF2" }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: "#6B7280", mb: 1.5, fontSize: "0.82rem" }}>
                      Matching Assets ({searchResults.length}):
                    </Typography>
                    <Grid container spacing={1.5}>
                      {searchResults.map((asset) => (
                        <Grid item xs={12} sm={6} md={4} key={asset.AssetId}>
                          <Paper
                            variant="outlined"
                            onClick={() => handleSelectAsset(asset)}
                            sx={{
                              p: 1.5,
                              borderRadius: "10px",
                              cursor: "pointer",
                              borderColor: "#ECEEF2",
                              bgcolor: "#FAFBFC",
                              transition: "all 0.15s ease",
                              "&:hover": {
                                borderColor: accentColor,
                                bgcolor: `${accentColor}06`
                              }
                            }}
                          >
                            <Stack direction="row" spacing={1.5} alignItems="center">
                              <Box
                                component="img"
                                src={asset.AssetImageUrl || assetPlaceholder}
                                sx={{ width: 44, height: 44, borderRadius: "8px", objectFit: "cover", border: "1px solid #ECEEF2" }}
                              />
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: "#1A1D23", fontSize: "0.85rem" }} noWrap>
                                  {asset.AssetCode} &bull; {asset.AssetName}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "#9499A8", display: "block", fontSize: "0.75rem" }} noWrap>
                                  {asset.CategoryName} &bull; {asset.LocationTitle || asset.Location}
                                </Typography>
                              </Box>
                            </Stack>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
              </CardContent>
            </Card>

            {/* Identified Asset Hero Card */}
            {currentAsset && (
              <Card
                variant="outlined"
                sx={{
                  borderRadius: "14px",
                  bgcolor: "#FFFFFF",
                  border: "1px solid #ECEEF2"
                }}
              >
                <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={3}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    justifyContent="space-between"
                  >
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2.5} alignItems="center" sx={{ flex: 1 }}>
                      <CardMedia
                        component="img"
                        image={currentAsset.AssetImageUrl || assetPlaceholder}
                        alt={currentAsset.AssetName}
                        sx={{
                          width: 88,
                          height: 88,
                          borderRadius: "12px",
                          objectFit: "cover",
                          border: "1px solid #ECEEF2"
                        }}
                      />

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Stack direction="row" spacing={1.2} alignItems="center" flexWrap="wrap">
                          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1A1D23", fontSize: "1rem" }}>
                            {currentAsset.AssetName}
                          </Typography>
                          <Chip
                            size="small"
                            label={currentAsset.StatusTypeName || "Active"}
                            sx={{
                              fontWeight: 600,
                              borderRadius: "6px",
                              fontSize: "0.72rem",
                              height: 20,
                              ...getStatusColors(currentAsset.StatusTypeName)
                            }}
                          />
                        </Stack>

                        <Typography variant="caption" sx={{ color: "#64748B", display: "block", fontSize: "0.8rem", mt: 0.3 }}>
                          Category: <strong style={{ color: "#1E293B" }}>{renderWithItalicNA(currentAsset.CategoryName)}</strong> &bull; Subcategory: <strong style={{ color: "#1E293B" }}>{renderWithItalicNA(currentAsset.SubCategoryName)}</strong>
                        </Typography>

                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                          <Grid item xs={6} sm={3}>
                            <Typography sx={{ fontSize: "0.72rem", color: "#9499A8", fontWeight: 600, textTransform: "uppercase" }}>
                              Equipment #
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#1A1D23" }}>
                              {renderWithItalicNA(currentAsset.AssetCode)}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <Typography sx={{ fontSize: "0.72rem", color: "#9499A8", fontWeight: 600, textTransform: "uppercase" }}>
                              Serial #
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                              {renderWithItalicNA(currentAsset.SerialNo)}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <Typography sx={{ fontSize: "0.72rem", color: "#9499A8", fontWeight: 600, textTransform: "uppercase" }}>
                              Location
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }} noWrap>
                              {renderWithItalicNA(currentAsset.LocationTitle || currentAsset.Location)}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <Typography sx={{ fontSize: "0.72rem", color: "#9499A8", fontWeight: 600, textTransform: "uppercase" }}>
                              Assigned To
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }} noWrap>
                              {renderWithItalicNA(currentAsset.AssignedToName)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Stack>

                    <Button
                      variant="outlined"
                      startIcon={<SwapHorizIcon />}
                      onClick={handleResetAsset}
                      sx={{
                        borderRadius: "10px",
                        textTransform: "none",
                        borderColor: "#E5E7EB",
                        color: "#4B5563",
                        fontWeight: 600,
                        fontSize: "0.84rem",
                        px: 2,
                        py: 0.7,
                        alignSelf: { xs: "stretch", md: "center" },
                        "&:hover": { borderColor: accentColor, color: accentColor, bgcolor: "transparent" }
                      }}
                    >
                      Change Asset
                    </Button>
                  </Stack>

                  {/* Previous Check History Banner for this Asset */}
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      mt: 2,
                      borderRadius: "10px",
                      bgcolor: "#F0FDF4",
                      borderColor: "#BBF7D0"
                    }}
                  >
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1.5}
                      alignItems={{ xs: "flex-start", sm: "center" }}
                      justifyContent="space-between"
                    >
                      <Stack direction="row" spacing={1.2} alignItems="center">
                        <CheckCircleIcon sx={{ fontSize: 18, color: "#16A34A" }} />
                        <Box>
                          <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#14532D" }}>
                            Previous Check:{" "}
                            {lastCheckInfo ? (
                              <Typography component="span" sx={{ fontWeight: 500, color: "#166534" }}>
                                {moment(lastCheckInfo.dateTime).format("MMM DD, YYYY h:mm A")} by {lastCheckInfo.auditorName} ({lastCheckInfo.status})
                              </Typography>
                            ) : (
                              <Typography component="span" sx={{ fontWeight: 400, color: "#166534", fontStyle: "italic" }}>
                                No prior check recorded yet for this asset.
                              </Typography>
                            )}
                          </Typography>
                        </Box>
                      </Stack>

                      {lastCheckInfo && (
                        <Button
                          size="small"
                          variant="text"
                          startIcon={<HistoryIcon sx={{ fontSize: 16 }} />}
                          onClick={() => {
                            setHistoryScope("CURRENT_ASSET");
                            setActiveTab(1);
                          }}
                          sx={{
                            textTransform: "none",
                            color: "#15803D",
                            fontWeight: 700,
                            fontSize: "0.8rem",
                            p: 0,
                            "&:hover": { bgcolor: "transparent", textDecoration: "underline" }
                          }}
                        >
                          View History
                        </Button>
                      )}
                    </Stack>
                  </Paper>
                </CardContent>
              </Card>
            )}

            {/* Step 2: Dynamic Inspection Questions Form */}
            {!currentAsset ? (
              <Paper
                variant="outlined"
                sx={{
                  p: 6,
                  textAlign: "center",
                  borderRadius: "14px",
                  bgcolor: "#FFFFFF",
                  border: "1px dashed #CBD5E1"
                }}
              >
                <Box
                  sx={{
                    bgcolor: "#F5F6FA",
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2
                  }}
                >
                  <FactCheckIcon sx={{ fontSize: 28, color: "#9499A8" }} />
                </Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1A1D23" }}>
                  Identify Asset to Begin Inventory Check
                </Typography>
                <Typography variant="body2" sx={{ color: "#9499A8", mt: 0.5, maxWidth: 440, mx: "auto", fontSize: "0.85rem" }}>
                  Scan the asset barcode or search by equipment number in Step 1 to load the inspection questions.
                </Typography>
              </Paper>
            ) : (
              <Stack spacing={2.5}>
                {/* DYNAMIC INSPECTION QUESTIONS CARD */}
                <Card variant="outlined" sx={{ borderRadius: "14px", bgcolor: "#FFFFFF", border: "1px solid #ECEEF2" }}>
                  <Box sx={{ p: { xs: 2.5, sm: 3 }, borderBottom: "1px solid #F0F2F5" }}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="space-between">
                      <Box sx={{ flex: 1 }}>
                        <Stack direction="row" spacing={1.2} alignItems="center" flexWrap="wrap">
                          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: "1rem", color: "#1A1D23" }}>
                            Inspection Questions Checklist
                          </Typography>
                          {dynamicQuestions.length > 0 && (
                            <Chip
                              size="small"
                              label={`${dynamicQuestions.length} Questions`}
                              sx={{ height: 22, fontSize: "0.75rem", fontWeight: 700, bgcolor: `${accentColor}12`, color: accentColor }}
                            />
                          )}
                        </Stack>
                        <Typography variant="body2" sx={{ color: "#9499A8", fontSize: "0.8rem", mt: 0.3 }}>
                          Verify asset details against expected system values. Mark "No" to enter corrected values and notes.
                        </Typography>
                      </Box>

                      {availableForms.length > 1 && (
                        <FormControl size="small" sx={{ minWidth: 220, bgcolor: "#FAFBFC" }}>
                          <InputLabel>Active Form</InputLabel>
                          <Select
                            value={selectedFormId}
                            label="Active Form"
                            onChange={async (e) => {
                              const newFid = Number(e.target.value);
                              setSelectedFormId(newFid);
                              await loadFormAndQuestionsForAsset(currentAsset, newFid);
                            }}
                            sx={{ borderRadius: "8px", fontSize: "0.85rem" }}
                          >
                            {availableForms.map((f) => (
                              <MenuItem key={f.Id} value={f.Id}>
                                {f.FormName || `Form #${f.Id}`}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Stack>
                  </Box>

                    <Box sx={{ p: { xs: 2, sm: 3 } }}>
                    {loadingDynamicQuestions ? (
                      <Box sx={{ py: 6, textAlign: "center" }}>
                        <CircularProgress size={32} sx={{ color: accentColor }} />
                        <Typography sx={{ color: "#64748B", fontSize: "0.85rem", mt: 1.5, fontWeight: 500 }}>
                          Loading inspection questions...
                        </Typography>
                      </Box>
                    ) : dynamicQuestions.length === 0 ? (
                      <Box sx={{ py: 6, textAlign: "center", color: "#9499A8" }}>
                        <PlaylistAddCheckIcon sx={{ fontSize: 44, opacity: 0.3, mb: 1 }} />
                        <Typography variant="subtitle1" sx={{ color: "#374151", fontWeight: 600 }}>
                          No questions configured for this form
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: "0.82rem", mt: 0.5 }}>
                          Please contact your administrator to assign questions to this inventory check form.
                        </Typography>
                      </Box>
                    ) : (
                      <Stack spacing={2.5}>
                        {dynamicQuestions.map((q, idx) => {
                          const ans = dynamicAnswers[q.Id] || {};
                          const exp = getQuestionFieldAndExpected(q, currentAsset);
                          const isCorrect = ans.isCorrect !== false;
                          const fieldKey = exp.fieldKey;

                          // Case 0: Custom Question Type (toggle, checklist, dropdown, custom)
                          if (exp.isCustomType) {
                            const currentVal =
                              ans.correctedValue !== undefined && ans.correctedValue !== null && ans.correctedValue !== ""
                                ? ans.correctedValue
                                : (exp.customType === "checklist" ? "" : (exp.options?.[0] || ""));

                            return (
                              <Box
                                key={q.Id || idx}
                                sx={fieldCardSx}
                              >
                                <Stack spacing={1.8}>
                                  <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    spacing={2}
                                    alignItems={{ xs: "flex-start", sm: "center" }}
                                    justifyContent="space-between"
                                  >
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                        <Chip
                                          size="small"
                                          label={`#${q.OrderId || idx + 1}`}
                                          sx={{
                                            height: 22,
                                            fontSize: "0.74rem",
                                            fontWeight: 700,
                                            bgcolor: "#F1F5F9",
                                            color: "#334155"
                                          }}
                                        />
                                        <Chip
                                          size="small"
                                          label={exp.customType.toUpperCase()}
                                          sx={{
                                            height: 20,
                                            fontSize: "0.68rem",
                                            fontWeight: 700,
                                            bgcolor: `${accentColor}18`,
                                            color: accentColor,
                                            borderRadius: "4px"
                                          }}
                                        />
                                        <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#111827" }}>
                                          {q.QuestionTitle}
                                        </Typography>
                                      </Stack>
                                      {q.QuestionSubTitle && (
                                        <Typography sx={{ color: "#6B7280", fontSize: "0.82rem", mt: 0.4, pl: 0.5 }}>
                                          {q.QuestionSubTitle}
                                        </Typography>
                                      )}
                                    </Box>

                                    {/* Custom options control in place of Yes/No toggle */}
                                    <Box sx={{ flexShrink: 0 }}>
                                      <CustomQuestionFieldControl
                                        customType={exp.customType}
                                        options={exp.options}
                                        value={currentVal}
                                        selectedOptions={ans.selectedOptions || []}
                                        accentColor={accentColor}
                                        onChange={(newVal, newArr) => {
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: {
                                              ...prev[q.Id],
                                              correctedValue: newVal,
                                              expectedValue: exp.expectedValue || exp.options[0] || "",
                                              expectedValueType: exp.customType,
                                              correctedValueType: exp.customType,
                                              selectedOptions: newArr,
                                              isCorrect: true
                                            }
                                          }));
                                        }}
                                      />
                                    </Box>
                                  </Stack>

                                  {/* Feedback Chip and Note input */}
                                  <Box sx={{ pt: 0.5 }}>
                                    {currentVal ? (
                                      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.2 }}>
                                        <Typography sx={{ fontSize: "0.76rem", color: "#64748B", fontWeight: 600 }}>
                                          Selected Value:
                                        </Typography>
                                        <Chip
                                          size="small"
                                          label={currentVal}
                                          sx={{
                                            fontWeight: 650,
                                            fontSize: "0.8rem",
                                            height: 24,
                                            bgcolor: `${accentColor}15`,
                                            color: accentColor,
                                            border: `1px solid ${accentColor}30`
                                          }}
                                        />
                                      </Stack>
                                    ) : null}

                                    <TextField
                                      size="small"
                                      fullWidth
                                      placeholder="Add optional note or remark for this question (saved in correction_note)..."
                                      value={ans.correctionNote || ""}
                                      onChange={(e) => {
                                        const noteVal = e.target.value;
                                        setDynamicAnswers((prev) => ({
                                          ...prev,
                                          [q.Id]: { ...prev[q.Id], correctionNote: noteVal }
                                        }));
                                      }}
                                      sx={{ bgcolor: "#F8FAFC", "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: "0.82rem" } }}
                                    />
                                  </Box>
                                </Stack>
                              </Box>
                            );
                          }

                          // Case 1: Empty QuestionCode -> Simple True/False question
                          if (!exp.hasCode) {
                            return (
                              <Box
                                key={q.Id || idx}
                                sx={!isCorrect ? correctionCardSx : fieldCardSx}
                              >
                                <Stack spacing={1.8}>
                                  <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    spacing={2}
                                    alignItems={{ xs: "flex-start", sm: "center" }}
                                    justifyContent="space-between"
                                  >
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Stack direction="row" spacing={1} alignItems="center">
                                        <Chip
                                          size="small"
                                          label={`#${q.OrderId || idx + 1}`}
                                          sx={{
                                            height: 22,
                                            fontSize: "0.74rem",
                                            fontWeight: 700,
                                            bgcolor: isCorrect ? "#F1F5F9" : "#FEE2E2",
                                            color: isCorrect ? "#334155" : "#B91C1C"
                                          }}
                                        />
                                        <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#111827" }}>
                                          {q.QuestionTitle}
                                        </Typography>
                                      </Stack>
                                      {q.QuestionSubTitle && (
                                        <Typography sx={{ color: "#6B7280", fontSize: "0.82rem", mt: 0.4, pl: 0.5 }}>
                                          {q.QuestionSubTitle}
                                        </Typography>
                                      )}
                                    </Box>

                                    <TrueFalseToggle
                                      value={isCorrect}
                                      trueLabel="True"
                                      falseLabel="False"
                                      onChange={(val) => {
                                        setDynamicAnswers((prev) => {
                                          const curr = prev[q.Id] || {};
                                          return {
                                            ...prev,
                                            [q.Id]: {
                                              ...curr,
                                              isCorrect: val,
                                              expectedValue: "True",
                                              expectedValueType: "BOOLEAN",
                                              correctedValue: val ? "True" : "False",
                                              correctedValueType: "BOOLEAN"
                                            }
                                          };
                                        });
                                      }}
                                    />
                                  </Stack>

                                  {/* If False: just take note from user */}
                                  {!isCorrect && (
                                    <Box
                                      sx={{
                                        mt: 1,
                                        pt: 1.5,
                                        borderTop: "1px solid #FECACA"
                                      }}
                                    >
                                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 700, color: "#991B1B", mb: 0.6 }}>
                                        Note / Reason:
                                      </Typography>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        placeholder="Add note explaining why this is false (saved in correction_note)..."
                                        value={ans.correctionNote || ""}
                                        onChange={(e) => {
                                          const noteVal = e.target.value;
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: { ...prev[q.Id], correctionNote: noteVal }
                                          }));
                                        }}
                                        sx={{ bgcolor: "#FFFFFF", maxWidth: 600, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                      />
                                    </Box>
                                  )}
                                </Stack>
                              </Box>
                            );
                          }

                          // Case 2: QuestionCode is present -> Compare with Asset expected value
                          return (
                            <Box
                              key={q.Id || idx}
                              sx={!isCorrect ? correctionCardSx : fieldCardSx}
                            >
                              <Stack spacing={1.8}>
                                {/* Question Title & Subtitle + Yes/No Toggle */}
                                <Stack
                                  direction={{ xs: "column", sm: "row" }}
                                  spacing={2}
                                  alignItems={{ xs: "flex-start", sm: "center" }}
                                  justifyContent="space-between"
                                >
                                  <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                      <Chip
                                        size="small"
                                        label={`#${q.OrderId || idx + 1}`}
                                        sx={{
                                          height: 22,
                                          fontSize: "0.74rem",
                                          fontWeight: 700,
                                          bgcolor: isCorrect ? "#F1F5F9" : "#FEE2E2",
                                          color: isCorrect ? "#334155" : "#B91C1C"
                                        }}
                                      />
                                      <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#111827" }}>
                                        {q.QuestionTitle}
                                      </Typography>
                                    </Stack>
                                    {q.QuestionSubTitle && (
                                      <Typography sx={{ color: "#6B7280", fontSize: "0.82rem", mt: 0.4, pl: 0.5 }}>
                                        {q.QuestionSubTitle}
                                      </Typography>
                                    )}
                                  </Box>

                                  <Stack direction="row" spacing={1.2} alignItems="center" sx={{ flexShrink: 0 }}>
                                    <Typography sx={{ fontSize: "0.82rem", fontWeight: 650, color: "#475569" }}>
                                      Is this correct?
                                    </Typography>
                                    <YesNoPills
                                      value={isCorrect}
                                      onChange={(val) => {
                                        setDynamicAnswers((prev) => {
                                          const curr = prev[q.Id] || {};
                                          return {
                                            ...prev,
                                            [q.Id]: {
                                              ...curr,
                                              isCorrect: val,
                                              correctedValue: val ? exp.expectedValue : (curr.correctedValue || "")
                                            }
                                          };
                                        });
                                      }}
                                      accentColor={accentColor}
                                    />
                                  </Stack>
                                </Stack>

                                {/* Expected Value Box */}
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: 1.2,
                                    px: 1.6,
                                    py: 0.75,
                                    bgcolor: "#F8FAFC",
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "8px"
                                  }}
                                >
                                  <Typography sx={{ fontSize: "0.74rem", color: "#64748B", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                    Expected Value ({exp.expectedValueType}):
                                  </Typography>
                                  <Chip
                                    size="small"
                                    label={exp.expectedValue || "Not Specified"}
                                    sx={{
                                      fontWeight: 650,
                                      fontSize: "0.82rem",
                                      height: 24,
                                      bgcolor: "#FFFFFF",
                                      border: "1px solid #CBD5E1",
                                      color: "#1E293B"
                                    }}
                                  />
                                </Box>

                                {/* If User Selects "NO": Show Correction Controls & Correction Note Input */}
                                {!isCorrect && (
                                  <Box
                                    sx={{
                                      mt: 1.5,
                                      pt: 2,
                                      borderTop: "1px solid #FECACA",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 1.8
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#991B1B" }}>
                                      Select / Type Corrected Value:
                                    </Typography>

                                    {/* LOCATION Correction Control */}
                                    {fieldKey === "LOCATION" && (
                                      <Stack spacing={1.5}>
                                        <RadioGroup
                                          row
                                          value={ans.locationType || "place"}
                                          onChange={(e) => {
                                            const lType = e.target.value;
                                            let cVal = "";
                                            if (lType === "place") cVal = ans.correctedPlace || "";
                                            else if (lType === "job") cVal = ans.correctedJob ? `${ans.correctedJob.jobCode || ""} - ${ans.correctedJob.name || ""}` : "";
                                            else if (lType === "employee") cVal = ans.correctedLocationEmployee ? `${ans.correctedLocationEmployee.firstName || ""} ${ans.correctedLocationEmployee.lastName || ""}`.trim() : "";
                                            setDynamicAnswers((prev) => ({
                                              ...prev,
                                              [q.Id]: {
                                                ...prev[q.Id],
                                                locationType: lType,
                                                correctedValue: cVal,
                                                correctedValueType: "LOCATION"
                                              }
                                            }));
                                          }}
                                        >
                                          <FormControlLabel value="place" control={<Radio size="small" />} label="Place / Site" />
                                          <FormControlLabel value="job" control={<Radio size="small" />} label="Job / Project" />
                                          <FormControlLabel value="employee" control={<Radio size="small" />} label="Employee Location" />
                                        </RadioGroup>

                                        {ans.locationType === "place" && (
                                          <TextField
                                            size="small"
                                            fullWidth
                                            placeholder="Enter updated place / room / site name..."
                                            value={ans.correctedPlace || ""}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              setDynamicAnswers((prev) => ({
                                                ...prev,
                                                [q.Id]: { ...prev[q.Id], correctedPlace: val, correctedValue: val, correctedValueType: "LOCATION" }
                                              }));
                                            }}
                                            sx={{ bgcolor: "#FFFFFF", maxWidth: 500, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                          />
                                        )}

                                        {ans.locationType === "job" && (
                                          <Autocomplete
                                            size="small"
                                            options={jobsList}
                                            getOptionLabel={(opt) => `${opt.jobCode || ""} - ${opt.name || ""}`}
                                            value={ans.correctedJob || null}
                                            onChange={(e, val) => {
                                              const cVal = val ? `${val.jobCode || ""} - ${val.name || ""}` : "";
                                              setDynamicAnswers((prev) => ({
                                                ...prev,
                                                [q.Id]: { ...prev[q.Id], correctedJob: val, correctedValue: cVal, correctedValueType: "LOCATION" }
                                              }));
                                            }}
                                            renderInput={(params) => <TextField {...params} placeholder="Search Job / Project..." />}
                                            sx={{ bgcolor: "#FFFFFF", maxWidth: 500, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                          />
                                        )}

                                        {ans.locationType === "employee" && (
                                          <Autocomplete
                                            size="small"
                                            options={employeesList}
                                            getOptionLabel={(opt) => `${opt.firstName || ""} ${opt.lastName || ""}`.trim()}
                                            value={ans.correctedLocationEmployee || null}
                                            onChange={(e, val) => {
                                              const cVal = val ? `${val.firstName || ""} ${val.lastName || ""}`.trim() : "";
                                              setDynamicAnswers((prev) => ({
                                                ...prev,
                                                [q.Id]: { ...prev[q.Id], correctedLocationEmployee: val, correctedValue: cVal, correctedValueType: "LOCATION" }
                                              }));
                                            }}
                                            renderInput={(params) => <TextField {...params} placeholder="Search Employee..." />}
                                            sx={{ bgcolor: "#FFFFFF", maxWidth: 500, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                          />
                                        )}
                                      </Stack>
                                    )}

                                    {/* STATUS Correction Control */}
                                    {fieldKey === "STATUS" && (
                                      <FormControl size="small" sx={{ bgcolor: "#FFFFFF", maxWidth: 320 }}>
                                        <InputLabel>Correct Status</InputLabel>
                                        <Select
                                          value={ans.correctedStatus || ""}
                                          label="Correct Status"
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            setDynamicAnswers((prev) => ({
                                              ...prev,
                                              [q.Id]: { ...prev[q.Id], correctedStatus: val, correctedValue: val, correctedValueType: "STATUS" }
                                            }));
                                          }}
                                          sx={{ borderRadius: "8px" }}
                                        >
                                          {statusTypesList.length > 0 ? (
                                            statusTypesList.map((st) => (
                                              <MenuItem key={st.id || st.name} value={st.name || st.statusName}>
                                                {st.name || st.statusName}
                                              </MenuItem>
                                            ))
                                          ) : (
                                            ["Active", "Under Repair", "Damaged", "Missing / Lost", "Disposed", "In Storage"].map((s) => (
                                              <MenuItem key={s} value={s}>{s}</MenuItem>
                                            ))
                                          )}
                                        </Select>
                                      </FormControl>
                                    )}

                                    {/* CATEGORY Correction Control */}
                                    {fieldKey === "CATEGORY" && (
                                      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ maxWidth: 640 }}>
                                        <Autocomplete
                                          size="small"
                                          fullWidth
                                          options={categoriesList}
                                          getOptionLabel={(opt) => opt.name || opt.label || ""}
                                          value={ans.correctedCategory || null}
                                          onChange={(e, val) => {
                                            const cVal = val ? `${val.name || ""}${ans.correctedSubCategory ? ` / ${ans.correctedSubCategory.name}` : ""}` : "";
                                            setDynamicAnswers((prev) => ({
                                              ...prev,
                                              [q.Id]: { ...prev[q.Id], correctedCategory: val, correctedValue: cVal, correctedValueType: "CATEGORY" }
                                            }));
                                          }}
                                          renderInput={(params) => <TextField {...params} label="Correct Category" />}
                                          sx={{ bgcolor: "#FFFFFF", "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                        />
                                        <Autocomplete
                                          size="small"
                                          fullWidth
                                          options={subCategoriesList}
                                          getOptionLabel={(opt) => opt.name || opt.label || ""}
                                          value={ans.correctedSubCategory || null}
                                          onChange={(e, val) => {
                                            const cVal = `${ans.correctedCategory?.name || ""}${val ? ` / ${val.name || ""}` : ""}`;
                                            setDynamicAnswers((prev) => ({
                                              ...prev,
                                              [q.Id]: { ...prev[q.Id], correctedSubCategory: val, correctedValue: cVal, correctedValueType: "CATEGORY" }
                                            }));
                                          }}
                                          renderInput={(params) => <TextField {...params} label="Correct Subcategory" />}
                                          sx={{ bgcolor: "#FFFFFF", "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                        />
                                      </Stack>
                                    )}

                                    {/* ASSIGNED EMPLOYEE Correction Control */}
                                    {fieldKey === "ASSIGNED_EMPLOYEE" && (
                                      <Autocomplete
                                        size="small"
                                        options={employeesList}
                                        getOptionLabel={(opt) => `${opt.firstName || ""} ${opt.lastName || ""}`.trim()}
                                        value={ans.correctedEmployee || null}
                                        onChange={(e, val) => {
                                          const cVal = val ? `${val.firstName || ""} ${val.lastName || ""}`.trim() : "";
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: { ...prev[q.Id], correctedEmployee: val, correctedValue: cVal, correctedValueType: "EMPLOYEE" }
                                          }));
                                        }}
                                        renderInput={(params) => <TextField {...params} placeholder="Search Assigned Employee..." />}
                                        sx={{ bgcolor: "#FFFFFF", maxWidth: 500, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                      />
                                    )}

                                    {/* CONDITION Correction Control */}
                                    {fieldKey === "CONDITION" && (
                                      <Stack spacing={1.5} sx={{ maxWidth: 500 }}>
                                        <FormControl size="small" sx={{ bgcolor: "#FFFFFF" }}>
                                          <InputLabel>Damage Severity</InputLabel>
                                          <Select
                                            value={ans.damageSeverity || "Minor Damage"}
                                            label="Damage Severity"
                                            onChange={(e) => {
                                              const sev = e.target.value;
                                              setDynamicAnswers((prev) => ({
                                                ...prev,
                                                [q.Id]: { ...prev[q.Id], damageSeverity: sev, correctedValue: sev, correctedValueType: "CONDITION" }
                                              }));
                                            }}
                                            sx={{ borderRadius: "8px" }}
                                          >
                                            <MenuItem value="Minor Damage">Minor Damage (Cosmetic / Usable)</MenuItem>
                                            <MenuItem value="Moderate Damage">Moderate Damage (Needs Repair)</MenuItem>
                                            <MenuItem value="Severe / Out of Service">Severe / Out of Service</MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Stack>
                                    )}

                                    {/* NUMBER Correction Control */}
                                    {fieldKey === "NUMBER" && (
                                      <TextField
                                        size="small"
                                        type="number"
                                        placeholder="Enter corrected number..."
                                        value={ans.correctedValue || ""}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: { ...prev[q.Id], correctedValue: val, correctedValueType: "NUMBER" }
                                          }));
                                        }}
                                        sx={{ bgcolor: "#FFFFFF", maxWidth: 240, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                      />
                                    )}

                                    {/* TEXTAREA Correction Control */}
                                    {fieldKey === "TEXTAREA" && (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        placeholder="Enter corrected details..."
                                        value={ans.correctedValue || ""}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: { ...prev[q.Id], correctedValue: val, correctedValueType: "TEXTAREA" }
                                          }));
                                        }}
                                        sx={{ bgcolor: "#FFFFFF", maxWidth: 600, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                      />
                                    )}

                                    {/* DEFAULT / TEXT / SERIAL / CODE / DESCRIPTION Control */}
                                    {["TEXT", "EQUIPMENT_NO", "SERIAL_NO", "DESCRIPTION", "IS_FOUND"].includes(fieldKey) && (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        placeholder={`Enter corrected ${q.QuestionTitle.toLowerCase()}...`}
                                        value={ans.correctedValue || ""}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: { ...prev[q.Id], correctedValue: val, correctedValueType: "TEXT" }
                                          }));
                                        }}
                                        sx={{ bgcolor: "#FFFFFF", maxWidth: 500, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                      />
                                    )}

                                    {/* CORRECTION NOTE INPUT */}
                                    <Box sx={{ mt: 0.5 }}>
                                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 700, color: "#475569", mb: 0.6 }}>
                                        Correction Note / Reason:
                                      </Typography>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1.5}
                                        placeholder="Add note explaining why this value is incorrect or needs updating (saved in correction_note)..."
                                        value={ans.correctionNote || ""}
                                        onChange={(e) => {
                                          const noteVal = e.target.value;
                                          setDynamicAnswers((prev) => ({
                                            ...prev,
                                            [q.Id]: { ...prev[q.Id], correctionNote: noteVal }
                                          }));
                                        }}
                                        sx={{ bgcolor: "#FFFFFF", maxWidth: 600, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                      />
                                    </Box>
                                  </Box>
                                )}
                              </Stack>
                            </Box>
                          );
                        })}
                      </Stack>
                    )}
                  </Box>
                </Card>

                {/* AUDIT NOTE & ATTACH ASSET PHOTOS */}
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: "14px",
                    bgcolor: "#FFFFFF",
                    border: "1px solid #ECEEF2"
                  }}
                >
                  <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
                    {/* General Audit Note */}
                    <Box sx={{ mb: 2.5 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#1A1D23", mb: 0.5 }}>
                        Audit Note / Observation
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#9499A8", fontSize: "0.82rem", mb: 1.2 }}>
                        Add any general notes, remarks, or observations regarding this physical inventory check
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        rows={2.5}
                        placeholder="e.g. Asset inspected on site, condition is good, label tag replaced..."
                        value={auditNotes}
                        onChange={(e) => setAuditNotes(e.target.value)}
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            fontSize: "0.85rem",
                            borderRadius: "10px",
                            bgcolor: "#FAFAFA"
                          }
                        }}
                      />
                    </Box>

                    <Divider sx={{ my: 2.2, borderColor: "#ECEEF2" }} />

                    <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#1A1D23", mb: 0.5 }}>
                      Attach Asset Photos
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#9499A8", fontSize: "0.82rem", mb: 2 }}>
                      Upload or snap physical asset photos to be saved with this inventory audit
                    </Typography>

                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      multiple
                      style={{ display: "none" }}
                      onChange={handlePhotoUpload}
                    />

                    <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ alignItems: "center" }}>
                      {photos.map((p, i) => (
                        <Box
                          key={i}
                          sx={{
                            position: "relative",
                            width: 80,
                            height: 80,
                            borderRadius: "10px",
                            overflow: "hidden",
                            border: "1px solid #ECEEF2"
                          }}
                        >
                          <Box
                            component="img"
                            src={p.url}
                            alt={`asset-photo-${i}`}
                            sx={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                            onClick={() => {
                              setPictureViewerList(photos.map((item) => ({ src: item.url })));
                              setPictureViewerIndex(i);
                              setPictureViewerOpen(true);
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => handleRemovePhoto(i)}
                            sx={{
                              position: "absolute",
                              top: 2,
                              right: 2,
                              bgcolor: "rgba(255,255,255,0.9)",
                              color: "#EF4444",
                              p: 0.3,
                              boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                              "&:hover": { bgcolor: "#FEE2E2" }
                            }}
                          >
                            <CloseIcon sx={{ fontSize: 12 }} />
                          </IconButton>
                        </Box>
                      ))}

                      <Box
                        onClick={() => fileInputRef.current?.click()}
                        sx={{
                          width: 80,
                          height: 80,
                          border: `2px dashed ${accentColor}66`,
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          bgcolor: `${accentColor}08`,
                          transition: "all 0.15s ease",
                          "&:hover": { borderColor: accentColor, bgcolor: `${accentColor}15` }
                        }}
                      >
                        <AddPhotoAlternateIcon sx={{ fontSize: 26, color: accentColor, mb: 0.3 }} />
                        <Typography sx={{ fontSize: "0.68rem", fontWeight: 700, color: accentColor }}>
                          Add Photo
                        </Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>

                {/* Submit Action Bar */}
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: "14px",
                    bgcolor: "#FFFFFF",
                    border: "1px solid #ECEEF2"
                  }}
                >
                  <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ width: "100%" }}
                    >
                      <Grid item xs={12} sm>
                        <Typography variant="body2" sx={{ color: "#9499A8", fontSize: "0.85rem" }}>
                          Physical audit record and all verified values will be recorded into history.
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm="auto" sx={{ ml: { sm: "auto" } }}>
                        <Stack direction="row" spacing={1.5} sx={{ justifyContent: { xs: "stretch", sm: "flex-end" } }}>
                          <Button
                            variant="outlined"
                            onClick={handleResetAsset}
                            sx={{
                              borderRadius: "10px",
                              textTransform: "none",
                              fontWeight: 600,
                              borderColor: "#E5E7EB",
                              color: "#4B5563",
                              px: 2.5,
                              fontSize: "0.88rem",
                              flex: { xs: 1, sm: "none" },
                              "&:hover": { borderColor: "#D1D5DB", bgcolor: "#F9FAFB" }
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="contained"
                            startIcon={submitting ? <CircularProgress size={16} sx={{ color: "#FFFFFF" }} /> : <SendIcon sx={{ fontSize: 16 }} />}
                            onClick={handleSubmitCheck}
                            disabled={submitting}
                            sx={{
                              borderRadius: "10px",
                              bgcolor: accentColor,
                              color: "#FFFFFF",
                              fontWeight: 650,
                              textTransform: "none",
                              px: 3.5,
                              py: 1,
                              fontSize: "0.88rem",
                              boxShadow: "none",
                              flex: { xs: 1, sm: "none" },
                              "&:hover": { bgcolor: accentColor, opacity: 0.92 }
                            }}
                          >
                            {submitting ? "Submitting..." : "Submit Inventory Check"}
                          </Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Stack>
            )}
          </Stack>
        )}

        {/* TAB 1: CHECK HISTORY */}
        {activeTab === 1 && (
          <Card
            variant="outlined"
            sx={{
              borderRadius: "14px",
              bgcolor: "#FFFFFF",
              border: "1px solid #ECEEF2"
            }}
          >
            <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems={{ xs: "flex-start", sm: "center" }}
                justifyContent="space-between"
                sx={{ width: "100%", mb: 3 }}
              >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1A1D23" }}>
                    Fixed Asset Inventory Check History
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#9499A8", fontSize: "0.82rem" }}>
                    Physical audit records with discrepancies, locations, and photos
                  </Typography>
                </Box>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1.2}
                  alignItems="center"
                  sx={{ ml: { sm: "auto" }, flexShrink: 0, width: { xs: "100%", sm: "auto" } }}
                >
                  <TextField
                    size="small"
                    placeholder="Search history..."
                    value={historySearch}
                    onChange={(e) => setHistorySearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#9499A8", fontSize: 18 }} />
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      width: { xs: "100%", sm: 260 },
                      bgcolor: "#FAFBFC",
                      "& .MuiOutlinedInput-root": {
                        height: 38,
                        borderRadius: "8px",
                        fontSize: "0.82rem",
                        "& fieldset": { borderColor: "#ECEEF2" },
                        "&:hover fieldset": { borderColor: accentColor },
                        "&.Mui-focused fieldset": { borderColor: accentColor }
                      }
                    }}
                  />
                  <IconButton
                    onClick={loadHistoryRecords}
                    sx={{
                      width: 38,
                      height: 38,
                      bgcolor: "#F5F6FA",
                      borderRadius: "8px",
                      color: accentColor,
                      border: "1px solid #ECEEF2",
                      flexShrink: 0,
                      "&:hover": { bgcolor: "#ECEEF2" }
                    }}
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </Stack>

              {historyLoading ? (
                <Box sx={{ py: 8, textAlign: "center" }}>
                  <CircularProgress size={32} sx={{ color: accentColor }} />
                  <Typography sx={{ color: "#64748B", fontSize: "0.85rem", mt: 1.5, fontWeight: 500 }}>
                    Loading inventory check history...
                  </Typography>
                </Box>
              ) : filteredHistory.length === 0 ? (
                <Box sx={{ py: 8, textAlign: "center", color: "#9499A8" }}>
                  <InventoryIcon sx={{ fontSize: 44, mb: 1, opacity: 0.3 }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#374151" }}>
                    No inventory checks recorded
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#9499A8", mt: 0.3, fontSize: "0.82rem" }}>
                    Completed physical asset checks will be listed here.
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1.5}>
                  {filteredHistory.map((item) => (
                    <Paper
                      key={item.id}
                      variant="outlined"
                      onClick={() => handleOpenHistoryDetail(item)}
                      sx={{
                        p: 2,
                        borderRadius: "12px",
                        borderColor: "#ECEEF2",
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: 2,
                        cursor: "pointer",
                        transition: "all 0.15s ease",
                        "&:hover": {
                          borderColor: accentColor,
                          bgcolor: "#FAFBFC"
                        }
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ rowGap: 0.8 }}>
                          <Box sx={{ display: "inline-flex", alignItems: "center" }}>
                            {item.assetCode && item.assetCode !== "N/A" ? (
                              <>
                                <Typography component="span" sx={{ fontWeight: 750, color: "#111827", fontSize: "0.94rem" }}>
                                  {item.assetCode}
                                </Typography>
                                {item.assetName && item.assetName !== item.assetCode && (
                                  <>
                                    <Typography component="span" sx={{ color: "#9CA3AF", mx: 0.8, fontSize: "0.85rem" }}>
                                      &bull;
                                    </Typography>
                                    <Typography component="span" sx={{ fontWeight: 600, color: "#374151", fontSize: "0.92rem" }}>
                                      {item.assetName}
                                    </Typography>
                                  </>
                                )}
                              </>
                            ) : (
                              <Typography component="span" sx={{ fontWeight: 750, color: "#111827", fontSize: "0.94rem" }}>
                                {item.assetName || "Fixed Asset"}
                              </Typography>
                            )}
                          </Box>

                          <Chip
                            size="small"
                            label={item.resultStatus || "Verified"}
                            sx={{
                              height: 20,
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              borderRadius: "6px",
                              ...getStatusColors(item.resultStatus)
                            }}
                          />

                          {item.formName && (
                            <Chip
                              size="small"
                              label={item.formName}
                              sx={{
                                height: 20,
                                fontSize: "0.68rem",
                                fontWeight: 600,
                                borderRadius: "6px",
                                bgcolor: "#F1F5F9",
                                color: "#475569",
                                border: "1px solid #E2E8F0"
                              }}
                            />
                          )}
                        </Stack>

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 0.5, sm: 2.5 }} sx={{ mt: 0.8 }}>
                          <Typography variant="caption" sx={{ color: "#64748B" }}>
                            <strong>Date/Time:</strong> {moment(item.dateTime).format("MMM DD, YYYY h:mm A")}
                          </Typography>
                          <Typography variant="caption" sx={{ color: "#64748B" }}>
                            <strong>Auditor:</strong> {item.auditorName}
                          </Typography>
                          {item.location && item.location !== "Not Specified" && (
                            <Typography variant="caption" sx={{ color: "#64748B" }}>
                              <strong>Location:</strong> {item.location}
                            </Typography>
                          )}
                        </Stack>

                        {item.notes && (
                          <Typography variant="caption" sx={{ color: "#475569", display: "block", mt: 0.6, fontWeight: 500 }}>
                            &ldquo;{item.notes}&rdquo;
                          </Typography>
                        )}
                      </Box>

                      <Stack direction="row" spacing={1.5} alignItems="center">
                        {item.photos && item.photos.length > 0 && (
                          <Chip
                            size="small"
                            icon={<AddPhotoAlternateIcon sx={{ fontSize: 13 }} />}
                            label={`${item.photos.length}`}
                            sx={{ height: 22, fontSize: "0.72rem", bgcolor: "#F5F6FA", fontWeight: 600, borderRadius: "6px" }}
                          />
                        )}
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenHistoryDetail(item);
                          }}
                          endIcon={<VisibilityIcon sx={{ fontSize: 14 }} />}
                          sx={{
                            borderRadius: "8px",
                            textTransform: "none",
                            borderColor: "#ECEEF2",
                            color: "#4B5563",
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            px: 1.5,
                            py: 0.4
                          }}
                        >
                          Details
                        </Button>
                      </Stack>
                    </Paper>
                  ))}
                </Stack>
              )}
            </CardContent>
          </Card>
        )}
      </Box>

      {/* History Detail Dialog */}
      {selectedHistoryDetail && (
        <Dialog
          open={Boolean(selectedHistoryDetail)}
          onClose={() => setSelectedHistoryDetail(null)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              boxShadow: "0 20px 40px -15px rgba(0,0,0,0.15)",
              border: "1px solid #E2E8F0",
              overflow: "hidden"
            }
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2.5,
              bgcolor: "#F8FAFC",
              borderBottom: "1px solid #E2E8F0"
            }}
          >
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "10px",
                  bgcolor: `${accentColor}18`,
                  color: accentColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <FactCheckIcon sx={{ fontSize: 24 }} />
              </Box>
              <Box>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="h6" sx={{ fontWeight: 700, color: "#0F172A", fontSize: "1.05rem", lineHeight: 1.2 }}>
                    {selectedHistoryDetail.formName || "Inspection Check"}
                  </Typography>
                  <Chip
                    size="small"
                    label={selectedHistoryDetail.resultStatus || "Verified"}
                    sx={{
                      fontWeight: 700,
                      height: 22,
                      borderRadius: "6px",
                      fontSize: "0.72rem",
                      ...getStatusColors(selectedHistoryDetail.resultStatus)
                    }}
                  />
                </Stack>
                <Typography variant="caption" sx={{ color: "#64748B", mt: 0.3, display: "block" }}>
                  {selectedHistoryDetail.formDescription || "Physical Asset Inventory Verification Record"}
                </Typography>
              </Box>
            </Stack>

            <IconButton
              size="small"
              onClick={() => setSelectedHistoryDetail(null)}
              sx={{
                color: "#64748B",
                bgcolor: "#FFFFFF",
                border: "1px solid #E2E8F0",
                "&:hover": { bgcolor: "#F1F5F9" }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Stack spacing={3}>
              {/* Top Summary Info - 3 Equal Balanced Modern Cards */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                  gap: 2,
                  width: "100%"
                }}
              >
                {/* 1. Asset Information */}
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2.2,
                    borderRadius: "12px",
                    bgcolor: "#FFFFFF",
                    borderColor: "#E2E8F0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.03)"
                  }}
                >
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.2 }}>
                      <Box sx={{ p: 0.6, borderRadius: "6px", bgcolor: "#F1F5F9", color: "#475569", display: "flex" }}>
                        <InventoryIcon sx={{ fontSize: 16 }} />
                      </Box>
                      <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#64748B", textTransform: "uppercase", letterSpacing: 0.5 }}>
                        Asset Details
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mb: 1 }}>
                      <Chip
                        label={selectedHistoryDetail.assetCode || `Asset #${selectedHistoryDetail.assetId}`}
                        size="small"
                        sx={{
                          fontWeight: 700,
                          bgcolor: "#0F172A",
                          color: "#FFFFFF",
                          borderRadius: "6px",
                          fontSize: "0.75rem",
                          height: 22
                        }}
                      />
                      <Typography sx={{ fontWeight: 700, color: "#0F172A", fontSize: "0.92rem", lineHeight: 1.3 }}>
                        {selectedHistoryDetail.assetName || "Fixed Asset"}
                      </Typography>
                    </Stack>
                  </Box>

                  <Box sx={{ mt: 1.5, pt: 1, borderTop: "1px dashed #E2E8F0" }}>
                    <Typography sx={{ fontSize: "0.74rem", color: "#475569" }}>
                      <strong>Category:</strong> {selectedHistoryDetail.categoryName || "General"}
                    </Typography>
                    <Typography sx={{ fontSize: "0.74rem", color: "#475569", mt: 0.3, wordBreak: "break-all" }}>
                      <strong>Serial No:</strong> {selectedHistoryDetail.serialNo || "N/A"}
                    </Typography>
                  </Box>
                </Paper>

                {/* 2. Auditor & Date */}
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2.2,
                    borderRadius: "12px",
                    bgcolor: "#FFFFFF",
                    borderColor: "#E2E8F0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.03)"
                  }}
                >
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.2 }}>
                      <Box sx={{ p: 0.6, borderRadius: "6px", bgcolor: "#F1F5F9", color: "#475569", display: "flex" }}>
                        <PersonIcon sx={{ fontSize: 16 }} />
                      </Box>
                      <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#64748B", textTransform: "uppercase", letterSpacing: 0.5 }}>
                        Auditor & Time
                      </Typography>
                    </Stack>
                    <Typography sx={{ fontSize: "0.92rem", fontWeight: 700, color: "#0F172A" }}>
                      {selectedHistoryDetail.auditorName || "Field Auditor"}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#64748B", fontSize: "0.72rem", display: "block", mt: 0.3 }}>
                      Record ID: #{selectedHistoryDetail.id || selectedHistoryDetail.formResponseId}
                    </Typography>
                  </Box>

                  <Box sx={{ mt: 1.5, pt: 1, borderTop: "1px dashed #E2E8F0" }}>
                    <Stack direction="row" spacing={0.6} alignItems="center">
                      <CalendarTodayIcon sx={{ fontSize: 13, color: "#64748B" }} />
                      <Typography sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#1E293B" }}>
                        {moment(selectedHistoryDetail.dateTime).format("MMM DD, YYYY • h:mm A")}
                      </Typography>
                    </Stack>
                  </Box>
                </Paper>

                {/* 3. Audit Note */}
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2.2,
                    borderRadius: "12px",
                    bgcolor: "#FAFAFA",
                    borderColor: "#E2E8F0",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.03)"
                  }}
                >
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.2 }}>
                    <Box sx={{ p: 0.6, borderRadius: "6px", bgcolor: "#FFFFFF", color: accentColor, display: "flex", border: "1px solid #E2E8F0" }}>
                      <ChatBubbleOutlineIcon sx={{ fontSize: 14 }} />
                    </Box>
                    <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: 0.5 }}>
                      Audit Note
                    </Typography>
                  </Stack>
                  <Box sx={{ flex: 1, overflowY: "auto", maxHeight: 95 }}>
                    <Typography variant="body2" sx={{ color: "#1E293B", fontSize: "0.84rem", fontStyle: selectedHistoryDetail.notes ? "normal" : "italic", fontWeight: 500, lineHeight: 1.4 }}>
                      {selectedHistoryDetail.notes ? `"${selectedHistoryDetail.notes}"` : "No specific audit notes recorded."}
                    </Typography>
                  </Box>
                </Paper>
              </Box>

              {/* Submitted Question Answers */}
              <Box sx={{ mt: 1 }}>
                <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1.5 }}>
                  <PlaylistAddCheckIcon sx={{ fontSize: 20, color: accentColor }} />
                  <Typography sx={{ fontSize: "0.78rem", color: "#334155", fontWeight: 750, textTransform: "uppercase", letterSpacing: 0.6 }}>
                    INSPECTION CHECKLIST RESPONSES
                  </Typography>
                  {selectedHistoryDetail.questionResponses && selectedHistoryDetail.questionResponses.length > 0 && (
                    <Chip
                      size="small"
                      label={`${selectedHistoryDetail.questionResponses.length} questions`}
                      sx={{ height: 19, fontSize: "0.68rem", fontWeight: 600, bgcolor: "#F1F5F9", color: "#475569" }}
                    />
                  )}
                  {detailLoading && <CircularProgress size={14} sx={{ color: accentColor }} />}
                </Stack>

                {detailLoading ? (
                  <Box sx={{ py: 4, textAlign: "center", bgcolor: "#F8FAFC", borderRadius: "10px", border: "1px dashed #CBD5E1" }}>
                    <CircularProgress size={22} sx={{ color: accentColor }} />
                    <Typography sx={{ color: "#64748B", fontSize: "0.8rem", mt: 1, fontWeight: 500 }}>
                      Fetching submitted checklist answers...
                    </Typography>
                  </Box>
                ) : selectedHistoryDetail.questionResponses && selectedHistoryDetail.questionResponses.length > 0 ? (
                  <Paper variant="outlined" sx={{ borderRadius: "12px", overflow: "hidden", borderColor: "#E2E8F0" }}>
                    <Stack divider={<Divider sx={{ borderColor: "#F1F5F9" }} />}>
                      {selectedHistoryDetail.questionResponses.map((qr, idx) => {
                        const isDuplicateSubtitle = qr.questionSubTitle && qr.questionSubTitle.trim() === (qr.questionTitle || "").trim();
                        const isExpectedQuestionTitle = qr.expectedValue && (qr.expectedValue.includes("?") || qr.expectedValue === qr.questionTitle);
                        const displayExpected = isExpectedQuestionTitle ? "Standard" : qr.expectedValue || "N/A";

                        return (
                          <Box
                            key={idx}
                            sx={{
                              p: 2,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              gap: 2,
                              bgcolor: idx % 2 === 0 ? "#FFFFFF" : "#F8FAFC"
                            }}
                          >
                            <Box sx={{ flex: 1 }}>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <Typography sx={{ fontSize: "0.88rem", fontWeight: 700, color: "#0F172A" }}>
                                  {qr.questionTitle || qr.title || `Question #${idx + 1}`}
                                </Typography>
                                {qr.questionCode && (
                                  <Chip
                                    label={qr.questionCode}
                                    size="small"
                                    sx={{ height: 18, fontSize: "0.65rem", fontWeight: 700, bgcolor: "#E2E8F0", color: "#475569" }}
                                  />
                                )}
                              </Stack>
                              {qr.questionSubTitle && !isDuplicateSubtitle && (
                                <Typography sx={{ fontSize: "0.76rem", color: "#64748B", mt: 0.3 }}>
                                  {qr.questionSubTitle}
                                </Typography>
                              )}

                              {qr.isCorrect === false && (
                                <Box sx={{ mt: 1, p: 1.2, bgcolor: "#FEF2F2", borderRadius: "8px", border: "1px solid #FEE2E2" }}>
                                  <Typography sx={{ fontSize: "0.78rem", color: "#991B1B", fontWeight: 600 }}>
                                    Expected: <span style={{ textDecoration: "line-through", color: "#6B7280" }}>{displayExpected}</span> &rarr; Corrected: <strong style={{ color: "#DC2626" }}>{qr.correctedValue || "N/A"}</strong>
                                  </Typography>
                                  {qr.correctionNote && qr.correctionNote !== qr.correctedValue && (
                                    <Typography sx={{ fontSize: "0.74rem", color: "#B91C1C", mt: 0.4, fontStyle: "italic" }}>
                                      Note: {qr.correctionNote}
                                    </Typography>
                                  )}
                                </Box>
                              )}
                            </Box>

                            <Chip
                              size="small"
                              label={
                                qr.isCorrect !== false
                                  ? String(qr.correctedValue || qr.expectedValue || "Yes")
                                  : "DISCREPANCY"
                              }
                              sx={{
                                fontWeight: 700,
                                fontSize: "0.74rem",
                                borderRadius: "6px",
                                bgcolor: qr.isCorrect !== false ? "#DCFCE7" : "#FEE2E2",
                                color: qr.isCorrect !== false ? "#15803D" : "#B91C1C"
                              }}
                            />
                          </Box>
                        );
                      })}
                    </Stack>
                  </Paper>
                ) : (
                  <Paper variant="outlined" sx={{ p: 2.5, textAlign: "center", borderRadius: "10px", bgcolor: "#F8FAFC", borderColor: "#E2E8F0" }}>
                    <Typography sx={{ fontSize: "0.82rem", color: "#94A3B8", fontStyle: "italic" }}>
                      No specific checklist answers recorded for this check.
                    </Typography>
                  </Paper>
                )}
              </Box>

              {/* Attached Photos */}
              {selectedHistoryDetail.photos && selectedHistoryDetail.photos.length > 0 && (
                <Box>
                  <Typography sx={{ fontSize: "0.74rem", color: "#475569", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
                    ATTACHED PHOTOS ({selectedHistoryDetail.photos.length})
                  </Typography>
                  <Stack direction="row" spacing={1.5} flexWrap="wrap">
                    {selectedHistoryDetail.photos.map((src, i) => (
                      <Box
                        key={i}
                        component="img"
                        src={src}
                        alt="Audit Photo"
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "10px",
                          objectFit: "cover",
                          cursor: "pointer",
                          border: "2px solid #E2E8F0",
                          transition: "all 0.15s ease",
                          "&:hover": {
                            borderColor: accentColor,
                            transform: "scale(1.04)"
                          }
                        }}
                        onClick={() => {
                          setPictureViewerList(selectedHistoryDetail.photos.map((p) => ({ src: p })));
                          setPictureViewerIndex(i);
                          setPictureViewerOpen(true);
                        }}
                      />
                    ))}
                  </Stack>
                </Box>
              )}
            </Stack>
          </DialogContent>

          <DialogActions sx={{ p: 2, px: 3, bgcolor: "#F8FAFC", borderTop: "1px solid #E2E8F0" }}>
            <Button
              variant="contained"
              onClick={() => setSelectedHistoryDetail(null)}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                bgcolor: accentColor,
                "&:hover": { bgcolor: accentColor, opacity: 0.9 }
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Asset Barcode / QR Scanner Dialog */}
      {scannerOpen && (
        <AssetBarcodeScanner
          open={scannerOpen}
          onClose={() => setScannerOpen(false)}
          onScanResult={handleBarcodeLookup}
        />
      )}

      {/* Picture Viewer Modal */}
      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={pictureViewerList}
          viewerIndex={pictureViewerIndex}
        />
      )}
    </Box>
  );
};

export default InventoryCheck;
